import React, { Component } from 'react'
import {
  getQuantity, getDescription, getPacking, getMask, getShipper, getShippingBehalf, getNetWeight,
  getLoadingDate, getPlaceLoading, getShippingPort, getCarrayVessel, getDestination, getGrossWeight,
  getTareWeight, getExportLicense, addCommaInNumber, getEachNetWeight, getEachGrossWeight, convertRiceTypeENToENFull
} from '../../helpers/function';
import { Container, Button } from 'react-bootstrap';
import { AdminNav } from '../../helpers';
import jsPDF from 'jspdf';
import OrderCertificate from '../../components/Order/OrderCertificate';
// import certificateForm from './checkweightform.jpeg'
import axios from 'axios';
import e from 'cors';
export default class CertiPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      CertificateSheetData: {},
      Token: 'token',
      redirect: false,
      CertificateSheetDataOnline: null,
      allCompany: null,
      viewFullNameRiceAsSample: null,
      isLoading: true,
    }
    this.handleCertificate = this.handleCertificate.bind(this)
    this.handleDescription = this.handleDescription.bind(this)
    this.saveCertificate = this.saveCertificate.bind(this)
  }
  renderQuantity(paragraph, newHandleData) {
    if (paragraph == '- bags') {
      return `${addCommaInNumber(getNetWeight(newHandleData))}  kgs.nett`
    } else {
      return paragraph
    }
  }
  isInbulk(handleData,subID) {
    if (handleData['PackingType'] != 'in  bulk') {
      if (getEachGrossWeight(handleData) == undefined) {
        return `${addCommaInNumber(getEachGrossWeight(handleData['description'][subID]))}  kgs.gross  and  ${addCommaInNumber(getEachNetWeight(handleData['description'][subID]))}  kgs.nett`
      } else {
        return `${addCommaInNumber(getEachGrossWeight(handleData))}  kgs.gross  and  ${addCommaInNumber(getEachNetWeight(handleData))}  kgs.nett`

      }
    } else {
      return ''
    }
  }
  renderCompany(companyObj, allCompany) {
    let viewAllCompany = allCompany
    let outputCompany = null
    Object.values(viewAllCompany).map((companyData) => {
      if (companyData['companyNameTH'].replace(/\s/g, '').trim() == companyObj.replace(/\s/g, '').trim()) {
        outputCompany = companyData['companyNameEN']
      }
    })
    if (companyObj == 'ไทยฮาจำกัด') {
      outputCompany = 'THAI HA PUBLIC CO., LTD.'
    } else if (companyObj == 'ไทยฟ้า(2511)จำกัด') {
      outputCompany = 'THAI HUA (2511) CO., LTD.'
    }
    if (outputCompany) {
      return outputCompany
    } else {
      return companyObj
    }
  }
  changeToUpper(a) {
    let company = a.toLowerCase()
    company = company.split(" ")
    let temp = ''
    // console.log(company)
    company.map((e, idx) => {
      if (e.trim() == 'fz') {
        temp += 'FZ  '
      }
      else if (e.trim() == 'chachoengsao') {
        temp += 'Chachoengsao, '
      }
      else if (e != 'of' && e.indexOf('(') == -1) {
        temp += `${(e.charAt(0).toUpperCase() + e.slice(1))}  `
      }
      else if (e.indexOf('(') != -1) {
        // console.log( e.charAt(1)) 
        temp += `${(e.charAt(0) + e.charAt(1).toUpperCase() + e.slice(2))}  `
      }
      else {
        temp += `${e}  `
      }
    })
    let strSplit = temp.split('')
    temp = ''
    strSplit.map((e, idx) => {
      // console.log(e)
      if (strSplit[idx - 1] == '.') {
        temp += `${e.toUpperCase()}`
      } else {
        temp += `${e}`
      }
    })
    return temp
  }
  changeCompany(a, allCompany) {
    try {
      let fullCompany = a.toUpperCase()
      let companyLength = Object.values(allCompany).filter((o) => { return o.companyNameEN == fullCompany })
      if (!companyLength[0]['companyNameENFull']) {
        let company = a.toLowerCase()

        company = company.split(" ")
        let temp = ''
        // console.log(company)
        company.map((e, idx) => {
          if (e.trim() == 'fz') {
            temp += 'FZ  '
          }
          else if (e.trim() == 'chachoengsao') {
            temp += 'Chachoengsao, '
          }
          else if (e != 'of' && e.indexOf('(') == -1) {
            temp += `${(e.charAt(0).toUpperCase() + e.slice(1))}  `
          }
          else if (e.indexOf('(') != -1) {
            // console.log( e.charAt(1))
            temp += `${(e.charAt(0) + e.charAt(1).toUpperCase() + e.slice(2))}  `
          }
          else {
            temp += `${e}  `
          }
        })
        let strSplit = temp.split('')
        temp = ''
        strSplit.map((e, idx) => {
          // console.log(e)
          if (strSplit[idx - 1] == '.') {
            temp += `${e.toUpperCase()}`
          } else {
            temp += `${e}`
          }
        })
        // console.log(temp)
        return temp
      } else {
        return companyLength[0]['companyNameENFull']
      }
    } catch (error) {
      return ''
    }
  }
  componentWillMount() {
    // let viewCheckWeightSheetByLicenseID = axios.post(
    //   'https://us-central1-riceinspection-16b06.cloudfunctions.net/middleWare',
    //   {
    //     action: 'viewCertificateSheetByLicenseID',
    //     data: {
    //       'jobID': this.props.location.state['jobID'],
    //       'licenseID': this.props.location.state['licenseID']
    //     },
    //   }
    // )
    let viewCheckWeightSheetByLicenseID = axios.post(
      'https://backend1.riceinspections.com/testDB',
      {
        data: {
          'jobID': this.props.location.state['jobID'],
          'licenseID': this.props.location.state['licenseID']
        },
      }
    )

    // `https://backend1.riceinspections.com/testDB`
    let viewFullNameRiceAsSample = fetch(`https://backend1.riceinspections.com/testFC`).then((res) => {
      return res.json()
    })
    let viewAllCompany = fetch(`https://backend1.riceinspections.com/testAB`).then((res) => {
      return res.json()
    })
    let viewAllSurveyPromise = fetch(`https://backend1.riceinspections.com/testBD`).then((res) => {
      return res.json()
    }) 

    Promise.all([viewCheckWeightSheetByLicenseID, viewAllCompany, viewFullNameRiceAsSample, viewAllSurveyPromise]).then((res) => {
      // console.log(res)
      function isEnglish(word) {
        // Replace this with your own logic to determine if a word is English
        // Here, we are assuming that a word is English if it consists of only letters (no numbers or special characters)
        return /^[a-zA-Z]+$/.test(word);
      }
      
      if (res[0].data) {
        let onlineData = Object.values(res[0].data)
        console.log(onlineData)
        onlineData = onlineData.filter((e) => { 

          return e['subID'] == this.props.location.state['subID'] && e['riceTypeID'] 
        })
        console.log(onlineData)
        // console.log(this.props.location.pageIndex)

        let handleData = this.props.location.state
        let CheckWeightSheet = this.props.location.state
        if (onlineData.length > 0) {
          onlineData = onlineData[0]
          console.log(onlineData['subID'])
          let englishRiceTypeID = ""
          if (isEnglish(onlineData['riceTypeID'])){
            englishRiceTypeID = onlineData['riceTypeID']
          }
          console.log(englishRiceTypeID)
          let dataFormated = {
            Certificate: {
              jobID: this.props.location.state['jobID'],
              description: {
                [this.props.location.pageIndex]: {
                  'No': onlineData['No'],
                  'NoOld': onlineData['NoOld'] || onlineData['No'],
                  'bagQuantity': onlineData['bagQuantity'] || this.renderQuantity(getQuantity(handleData), handleData),
                  'riceTypeID': onlineData['riceTypeID'] || convertRiceTypeENToENFull(getDescription(handleData)),
                  // 'riceTypeID': convertRiceTypeENToENFull(getDescription(handleData)),

                  'PackingType1': onlineData['PackingType1'] || getPacking(handleData),
                  'PackingType11': onlineData['PackingType11'] || '-',
                  'PackingType12': onlineData['PackingType12'] || '-',
                  'PackingType2': onlineData['PackingType2'] || this.isInbulk(handleData,this.props.location.pageIndex),
                  'logo': onlineData['logo'] || getMask(handleData),
                  'ShipperBehalf': onlineData['ShipperBehalf'] || 'xxxxxx',
                  'destinationCity': onlineData['destinationCity'] || this.changeToUpper(getDestination(handleData)),
                  'vehicleName': onlineData['vehicleName'] || getCarrayVessel(handleData),
                  'TotalGross': onlineData['TotalGross'] || getGrossWeight(handleData['description'][this.props.location.pageIndex]),
                  'TotalTare': onlineData['TotalTare'] || getTareWeight(handleData['description'][this.props.location.pageIndex]),
                  'TotalNett': onlineData['TotalNett'] || getNetWeight(handleData['description'][this.props.location.pageIndex]),
                  'License': onlineData['License'].slice(6, onlineData['License'].length),
                  'subID': onlineData['subID'],
                  'wtf1' : onlineData['wtf1']
                }
              },
              'currentDate': onlineData['currentDate'] || `${this.props.location.currentDate}`,
              'shippingDate': onlineData['shippingDate'] || getLoadingDate(CheckWeightSheet),
              'godown': getPlaceLoading(onlineData, res[3]) || getPlaceLoading(CheckWeightSheet, res[3]),
              'shippingPort': onlineData['shippingPort'] || 'Bangkok',
              'Quality1': onlineData['Quality1'] || "We  inspected  the  rice  at  time  and  place  of  loading  and  found  that  the  quality  of  rice",
              "Quality2": onlineData['Quality2'] || `conformed  with  Thai  Rice  Standards “${convertRiceTypeENToENFull(getDescription(handleData))}”`,
              "Weight": onlineData['Weight'] || `On  the  basis  of  random  weight  testing,  we  certify  the  loaded  weight  ${getQuantity(handleData)}  to  be:`,
              'title1': onlineData['title1'] || 'WE  HEREBY  CERTIFY  that  we  inspected  the  following  rice  shipment:-',
              'companyEN': onlineData['companyEN'] || this.changeCompany(this.renderCompany(CheckWeightSheet['companyID'], res[1]), res[1]),
            },
          }
          this.setState({
            ...this.state,
            CertificateSheetData: this.props.location.state,
            CertificateSheetDataOnline: dataFormated,
            allCompany: res[1],
            viewFullNameRiceAsSample: res[2],
            isLoading: false,
            survey: res[3],
          })
        } else {
          this.setState({
            ...this.state,
            CertificateSheetData: this.props.location.state,
            allCompany: res[1],
            viewFullNameRiceAsSample: res[2],
            isLoading: false,
            survey: res[3]
          })
        }
      } else {
        this.setState({
          ...this.state,
          CertificateSheetData: this.props.location.state,
          allCompany: res[1],
          viewFullNameRiceAsSample: res[2],
          isLoading: false,
          survey: res[3],
        })
      }
    })
    this.setState({
      ...this.state,
      CertificateSheetData: this.props.location.state,
    })
  }
  // static getDerivedStateFromError(error) {
  //   // Update state so the next render will show the fallback UI.
  //   return { redirect: true };
  // }

  handleDescription(e, idx) {
    let id = e.target.id
    let value = e.target.value
    if (id == 'PackingType1') {
      // let handleData = this.props.Certificate.description[this.props.desIndex]

      let handleData = this.props.location.state.description[this.props.location.pageIndex]
      // let CheckWeightSheet = this.props.location.state
      let quantity = handleData['bagQuantity'] || handleData['Quantity']
      console.log(handleData)
      quantity = quantity.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')

      let title = ''
      let grossWeight = getGrossWeight(handleData)
      let tarWeight = getTareWeight(handleData)
      if (value.toLowerCase() == 'in  plastic  bags  contained  in  cartons  of'.toLowerCase()) {
        quantity = `${quantity}  cartons`
        title = quantity
      }
      else if (value.toLowerCase() == 'in  plastic  bags  contained  in  tray  of'.toLowerCase()) {
        quantity = `${quantity}  trays`
        title = quantity
      }
      else if (value.toLowerCase() == 'Inner  PE  Outer  TRAY'.toLowerCase()) {
        quantity = `${quantity}  kgs.nett`
        title = quantity
      }
      else if (value.toLowerCase() == 'In  Bulk'.toLowerCase()) {
        title = `- bags`
        quantity = `${addCommaInNumber(getNetWeight(handleData))}  kgs.nett`
        grossWeight = '-'
        tarWeight = '-'
      }
      else {
        quantity = `${quantity}  bags`
        title = quantity
      }
      let packing2 = ''
      if (value.toLowerCase() != 'in  bulk'.toLowerCase()) {
        packing2 = `${addCommaInNumber(getEachGrossWeight(handleData))}  kgs.gross  and  ${addCommaInNumber(getEachNetWeight(handleData))}  kgs.nett`
      }
      this.setState({
        ...this.state,
        CertificateSheetDataOnline: {
          ...this.state.CertificateSheetDataOnline,
          Certificate: {
            ...this.state.CertificateSheetDataOnline.Certificate,
            description: {
              ...this.state.CertificateSheetDataOnline.Certificate.description,
              [idx]: {
                ...this.state.CertificateSheetDataOnline.Certificate.description[idx],
                [id]: value,
                ['bagQuantity']: quantity,
                ['PackingType2']: packing2,
                ['TotalGross']: grossWeight,
                ['TotalTare']: tarWeight,
                ['TotalNett']: getNetWeight(handleData),
              }
            },
            ['Weight']: `On  the  basis  of  random  weight  testing,  we  certify  the  loaded  weight  ${title}  to  be:`
          }
        }
      }, () => { console.log(this.state.CertificateSheetDataOnline) })
    } else {
      this.setState({
        ...this.state,
        CertificateSheetDataOnline: {
          ...this.state.CertificateSheetDataOnline,
          Certificate: {
            ...this.state.CertificateSheetDataOnline.Certificate,
            description: {
              ...this.state.CertificateSheetDataOnline.Certificate.description,
              [idx]: {
                ...this.state.CertificateSheetDataOnline.Certificate.description[idx],
                [id]: value
              }
            }
          }
        }
      })

    }
  }
  handleCertificate(e) {
    let id = e.target.id
    let value = e.target.value
    let tempData = {
      ...this.state,
      CertificateSheetDataOnline: {
        ...this.state.CertificateSheetDataOnline,
        Certificate: {
          ...this.state.CertificateSheetDataOnline.Certificate,
          [id]: value
        }
      }
    }
    this.setState({
      ...this.state,
      CertificateSheetDataOnline: {
        ...this.state.CertificateSheetDataOnline,
        Certificate: {
          ...this.state.CertificateSheetDataOnline.Certificate,
          [id]: value
        }
      }
    })
  }

  async printOutCertificate(idx, generalDescription, minusHeight = 0, minusCurrentDate = 0, minusCertNo = 0) {
    let doc = new jsPDF('p', 'mm', [840.51, 595.40])
    // doc.addImage(image, 'JPEG', 0, 0, 210, 297);
    // doc.save('test.pdf')
    // console.log(`helloworld minus = ${minusHeight}`)
    doc.setFont('Times', 'Roman')
    doc.setFontSize(11)
    // console.log(CheckWeightSheet)
    let handleData = generalDescription.description[idx]
    console.log(handleData)
    let CheckWeightSheet = generalDescription
    // console.log(handleData['wtf1'])
    let firstHeight = 81
    firstHeight -= minusHeight
    let currentCertNo = 29 - minusCertNo
    let currentDateHeight = firstHeight - 22.5
    let dateHeight = firstHeight - 20
    if (handleData['wtf3'] && handleData['PackingType2']) {
      let heightConst = 8
      // console.log(handleData)
      function getHeight(x, y) {
        if (y) {
          return firstHeight + (heightConst * x) + y
        } else {
          return firstHeight + (heightConst * x)
        }
      }
      doc.setFontSize(17)
      doc.text(handleData['No'], currentCertNo, dateHeight)
      doc.setFontSize(11)
      doc.text(CheckWeightSheet['currentDate'], 134 - minusCurrentDate, dateHeight)
      doc.setFontSize(6)
      if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) == 1) {
        doc.text(`st`, 135.7 - minusCurrentDate, currentDateHeight)
      }
      else if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) == 2) {
        doc.text(`nd`, 135.7 - minusCurrentDate, currentDateHeight)
      }
      else if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) == 3) {
        doc.text(`rd`, 135.7 - minusCurrentDate, currentDateHeight)
      }
      else if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) < 10) {
        doc.text(`th`, 135.7 - minusCurrentDate, currentDateHeight)
      }
      else if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) == 21 || parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) == 31) {
        doc.text(`st`, 138 - minusCurrentDate, currentDateHeight)
      }
      else if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) == 22) {
        doc.text(`nd`, 138 - minusCurrentDate, currentDateHeight)
      }
      else if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) == 23) {
        doc.text(`rd`, 138 - minusCurrentDate, currentDateHeight)
      }
      else if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) >= 10) {
        doc.text(`th`, 138 - minusCurrentDate, currentDateHeight)
      }
      doc.setFontSize(11)
      doc.text('WE HEREBY CERTIFY that we inspected the following rice shipment:-', 35, firstHeight - 10)
      let height = 0
      doc.text('Quantity : ', 17.5, getHeight(height))
      doc.text(handleData['bagQuantity'], 70, getHeight(height))
      height += 0.868
      doc.text('Description of goods : ', 17.5, getHeight(height))
      doc.setFontSize(10)
      doc.text(handleData['wtf1'], 70, getHeight(height))
      if (handleData['wtf3']) {
        height += 0.868
        doc.text(handleData['wtf2'], 70, getHeight(height))
        height += 0.868
        if (handleData['wtf3']) {
          doc.text(handleData['wtf3'], 70, getHeight(height))
          height += 0.868
        } else {
          height += 0.868
        }
      }
      doc.setFontSize(11)
      doc.text('Packing : ', 17.5, getHeight(height))
      doc.text(handleData['PackingType1'], 70, getHeight(height))
      height += 0.868
      if (handleData['PackingType11'] !== '-') {
        doc.text(handleData['PackingType11'], 70, getHeight(height))
        height += 0.868
      }
      if (handleData['PackingType12'] !== '-') {
        doc.text(handleData['PackingType12'], 70, getHeight(height))
        height += 0.868
      }

      doc.text(handleData['PackingType2'], 70, getHeight(height))
      height += 0.868
      doc.text('Mark : ', 17.5, getHeight(height))
      doc.text(handleData['logo'], 75, getHeight(height))
      height += 0.868
      doc.text('Shipper : ', 17.5, getHeight(height))
      doc.text(CheckWeightSheet['companyEN'], 70, getHeight(height))
      height += 0.868
      doc.text('Shipper on behalf of :', 17.5, getHeight(height))
      if (`${handleData['ShipperBehalf']}`.indexOf('xxxx') != -1){
        doc.text(handleData['ShipperBehalf'], 75, getHeight(height))
      }else{
        doc.text(handleData['ShipperBehalf'], 70, getHeight(height))
      }
      height += 0.868
      doc.text('Date of loading : ', 17.5, getHeight(height))

      let a1 = parseInt(CheckWeightSheet['shippingDate'].split(" ")[0])
      let a2 = CheckWeightSheet['shippingDate'].split(" ")[1]
      let a3 = CheckWeightSheet['shippingDate'].split(" ")[2]
      doc.text(`${CheckWeightSheet['shippingDate']}`, 70, getHeight(height))
      doc.setFontSize(6)
      if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) == 1) {
        doc.text(`st`, 71.7, getHeight(height, -2))
      }
      else if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) == 2) {
        doc.text(`nd`, 71.7, getHeight(height, -2))
      }
      else if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) == 3) {
        doc.text(`rd`, 71.7, getHeight(height, -2))
      }
      else if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) < 10) {
        doc.text(`th`, 71.7, getHeight(height, -2))
      }
      else if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) == 21 || parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) == 31) {
        doc.text(`st`, 74, getHeight(height, -2))
      }
      else if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) == 22) {
        doc.text(`nd`, 74, getHeight(height, -2))
      }
      else if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) == 23) {
        doc.text(`rd`, 74, getHeight(height, -2))
      }
      else if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) >= 10) {
        doc.text(`th`, 74, getHeight(height, -2))
      }
      height += 0.868
      doc.setFontSize(11)
      doc.text('Place of loading : ', 17.5, getHeight(height))
      doc.text(CheckWeightSheet['godown'], 70, getHeight(height))
      height += 0.868
      doc.text('Shipping port : ', 17.5, getHeight(height))
      doc.text(CheckWeightSheet['shippingPort'], 70, getHeight(height))
      height += 0.868
      doc.text('Carrying vessel : ', 17.5, getHeight(height))

      let vehicleKey = ''
      Object.keys(handleData).map((key) => { if (key.indexOf('vehicleName') != -1) vehicleKey = key })
      console.log(handleData[vehicleKey], vehicleKey)

      doc.setFontSize(10); doc.text(handleData[vehicleKey], 70, getHeight(height)); doc.setFontSize(11);
      height += 0.868
      doc.text('Destination : ', 17.5, getHeight(height))
      doc.text(handleData['destinationCity'], 70, getHeight(height))
      height += 0.868
      doc.text('Quality   :  ', 17.5, getHeight(height))
      let underLineWidth = parseFloat(doc.getTextWidth('Quality'))
      doc.line(17.5, getHeight(height, +1), 17.5 + underLineWidth, getHeight(height, +1))
      doc.text(CheckWeightSheet['Quality1'], 40.5, getHeight(height))
      doc.setFontSize(10)
      if (handleData['wtf3']) {
        height += 0.868
        let t = CheckWeightSheet['Quality2'].indexOf('“')
        t = CheckWeightSheet['Quality2'].slice(0, t)
        t = `${t} “`
        doc.text(t, 17.5, getHeight(height))
        doc.setFontSize(10)
        underLineWidth = parseFloat(doc.getTextWidth(handleData['wtf1']))
        let underLineWidth2 = parseFloat(doc.getTextWidth(t))
        doc.text(handleData['wtf1'], (17.5 + (underLineWidth2)), getHeight(height))
        height += 0.868

        doc.text(handleData['wtf2'], (17.5 + (underLineWidth2)), getHeight(height))
        height += 0.868
        if (handleData['wtf3']) {
          doc.text(`${handleData['wtf3']}”`, (17.5 + (underLineWidth2)), getHeight(height))
          height += 0.868
        } else {
          height += 0.868
        }
      }
      doc.setFontSize(11)


      doc.text('Weight   :   ', 17.5, getHeight(height))
      underLineWidth = parseFloat(doc.getTextWidth('Weight'))
      doc.line(17.5, getHeight(height, +1), 17.5 + underLineWidth, getHeight(height, +1))

      // console.log(CheckWeightSheet['Weight'])
      if (CheckWeightSheet['Weight'].indexOf('bags') != -1 || CheckWeightSheet['Weight'].indexOf('kgs.nett') != -1) {
        doc.text(CheckWeightSheet['Weight'].slice(0, 80), 35, getHeight(height))
        // console.log(CheckWeightSheet['Weight'].slice(80,CheckWeightSheet['Weight'].length-13))
        // console.log(CheckWeightSheet['Weight'].slice(CheckWeightSheet['Weight'].length-17,CheckWeightSheet['Weight'].length))
        doc.text(CheckWeightSheet['Weight'].slice(80, CheckWeightSheet['Weight'].length - 13), 160, getHeight(height), 'center')
        doc.text(CheckWeightSheet['Weight'].slice(CheckWeightSheet['Weight'].length - 13, CheckWeightSheet['Weight'].length), 167, getHeight(height))
        height += 0.868
        doc.text('Total gross :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalGross'])}  kgs.`, 186, getHeight(height), 'right')
        height += 0.868
        doc.text('Total tare :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalTare'])}  kgs.`, 186, getHeight(height), 'right')
        height += 0.868
        console.log(height)
        doc.text('Total nett :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalNett'])}  kgs.`, 186, getHeight(height), 'right')
        height = 23
        doc.text(`Export license No.         ${handleData['License']}`, 19, getHeight(height))
        // now is 18 
        // target is 19.375
        // doc.text('I have dream that be great cause it be power things I think it could give our power and brave for us. at least it will be power for nex generation people. I think it could give our power and brave for us. at least it will be power for I think it could give our power and brave for us. at least it will be power for', 19, getHeight(height), {maxWidth: 180, align: 'justify'});
        doc.autoPrint()
        doc.output('dataurlnewwindow');
        // doc.save(`030811${handleData['License']}.pdf`)
        //  CheckWeightSheet['Weight'].indexOf('cartons') != -1 
      }
      else if (CheckWeightSheet['Weight'].indexOf('cartons') != -1) {
        doc.text(CheckWeightSheet['Weight'].slice(0, 80), 35, getHeight(height))
        // console.log(CheckWeightSheet['Weight'].slice(80, CheckWeightSheet['Weight'].length - 17))
        doc.text(CheckWeightSheet['Weight'].slice(80, CheckWeightSheet['Weight'].length - 17), 158, getHeight(height), 'center')
        doc.text(CheckWeightSheet['Weight'].slice(CheckWeightSheet['Weight'].length - 17, CheckWeightSheet['Weight'].length), 163, getHeight(height))
        height += 0.868
        doc.text('Total gross :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalGross'])}  kgs.`, 187, getHeight(height), 'right')
        height += 0.868
        doc.text('Total tare :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalTare'])}  kgs.`, 187, getHeight(height), 'right')
        height += 0.868
        doc.text('Total nett :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalNett'])}  kgs.`, 187, getHeight(height), 'right')
        console.log(height)
        height = 23
        doc.text(`Export license No.         ${handleData['License']}`, 19, getHeight(height))
        doc.autoPrint()
        doc.output('dataurlnewwindow');
        //  CheckWeightSheet['Weight'].indexOf('cartons') != -1 
      }
      else if (CheckWeightSheet['Weight'].indexOf('trays') != -1) {
        doc.text(CheckWeightSheet['Weight'].slice(0, 80), 35, getHeight(height))
        // console.log(CheckWeightSheet['Weight'].slice(80, CheckWeightSheet['Weight'].length - 17))
        doc.text(CheckWeightSheet['Weight'].slice(80, CheckWeightSheet['Weight'].length - 16), 159, getHeight(height), 'center')
        doc.text(CheckWeightSheet['Weight'].slice(CheckWeightSheet['Weight'].length - 16, CheckWeightSheet['Weight'].length), 165, getHeight(height))
        height += 0.868
        doc.text('Total gross :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalGross'])}  kgs.`, 187, getHeight(height), 'right')
        height += 0.868
        doc.text('Total tare :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalTare'])}  kgs.`, 187, getHeight(height), 'right')
        height += 0.868
        doc.text('Total nett :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalNett'])}  kgs.`, 187, getHeight(height), 'right')
        console.log(height)
        height = 23
        doc.text(`Export license No.         ${handleData['License']}`, 19, getHeight(height))
        doc.autoPrint()
        doc.output('dataurlnewwindow');
        //  CheckWeightSheet['Weight'].indexOf('cartons') != -1 
      }
      else if (CheckWeightSheet['Weight'].indexOf('carton') != -1) {
        doc.text(CheckWeightSheet['Weight'].slice(0, 68), 40, getHeight(height))
        doc.text(CheckWeightSheet['Weight'].slice(68, CheckWeightSheet['Weight'].length - 14), 150, getHeight(height))
        doc.text(CheckWeightSheet['Weight'].slice(CheckWeightSheet['Weight'].length - 14, CheckWeightSheet['Weight'].length), 163, getHeight(height))
        height += 0.868
        doc.text('Total gross :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalGross'])}  kgs.`, 186, getHeight(height), 'right')
        height += 0.868
        doc.text('Total tare :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalTare'])}  kgs.`, 186, getHeight(height), 'right')
        height += 0.868
        doc.text('Total nett :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalNett'])}  kgs.`, 186, getHeight(height), 'right')
        height = 23
        doc.text(`Export license No.         ${handleData['License']}`, 19, getHeight(height))
        doc.autoPrint()
        doc.output('dataurlnewwindow');
        //  CheckWeightSheet['Weight'].indexOf('cartons') != -1  
        //CheckWeightSheet['Weight'].indexOf('carton') != -1
      }

      else if (CheckWeightSheet['Weight'].indexOf('pasteboard boxes') != -1) {
        doc.text(CheckWeightSheet['Weight'].slice(0, 68), 40, getHeight(height))
        doc.text(CheckWeightSheet['Weight'].slice(68, CheckWeightSheet['Weight'].length - 23), 146, getHeight(height))
        doc.text(CheckWeightSheet['Weight'].slice(CheckWeightSheet['Weight'].length - 23, CheckWeightSheet['Weight'].length - 6), 158, getHeight(height))
        height += 0.868
        doc.text(CheckWeightSheet['Weight'].slice(CheckWeightSheet['Weight'].length - 6, CheckWeightSheet['Weight'].length), 19, getHeight(height))
        // let a = CheckWeightSheet['Weight'].match(/\d+/g)
        // console.log(a[a.length-1])
        // console.log(CheckWeightSheet['Weight'].indexOf(a[0]))
        // console.log(CheckWeightSheet['Weight'].indexOf(a[1]))
        height += 0.868
        doc.text('Total gross :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalGross'])}  kgs.`, 186, getHeight(height), 'right')
        height += 0.868
        doc.text('Total tare :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalTare'])}  kgs.`, 186, getHeight(height), 'right')
        height += 0.868
        doc.text('Total nett :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalNett'])}  kgs.`, 186, getHeight(height), 'right')
        height = 23
        doc.text(`Export license No.         ${handleData['License']}`, 19, getHeight(height))
        doc.autoPrint()
        doc.output('dataurlnewwindow')
        // doc.save(`030811${handleData['License']}.pdf`)
      }
      else if (CheckWeightSheet['Weight'].indexOf('pasteboard boxes') != -1) {
        doc.text(CheckWeightSheet['Weight'].slice(0, 68), 40, getHeight(height))
        doc.text(CheckWeightSheet['Weight'].slice(68, CheckWeightSheet['Weight'].length - 23), 146, getHeight(height))
        doc.text(CheckWeightSheet['Weight'].slice(CheckWeightSheet['Weight'].length - 23, CheckWeightSheet['Weight'].length - 6), 158, getHeight(height))
        height += 0.868
        doc.text(CheckWeightSheet['Weight'].slice(CheckWeightSheet['Weight'].length - 6, CheckWeightSheet['Weight'].length), 19, getHeight(height))
        // let a = CheckWeightSheet['Weight'].match(/\d+/g)
        // console.log(a[a.length-1])
        // console.log(CheckWeightSheet['Weight'].indexOf(a[0]))
        // console.log(CheckWeightSheet['Weight'].indexOf(a[1]))
        height += 0.868
        doc.text('Total gross :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalGross'])}  kgs.`, 186, getHeight(height), 'right')
        height += 0.868
        doc.text('Total tare :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalTare'])}  kgs.`, 186, getHeight(height), 'right')
        height += 0.868
        doc.text('Total nett :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalNett'])}  kgs.`, 186, getHeight(height), 'right')
        height = 23
        doc.text(`Export license No.         ${handleData['License']}`, 19, getHeight(height))
        doc.autoPrint()
        doc.output('dataurlnewwindow');
        // doc.save(`030811${handleData['License']}.pdf`)
      }
    } else if (handleData['wtf2'] && handleData['PackingType2']) {
      let heightConst = 8
      // console.log(handleData)

      function getHeight(x, y) {
        if (y) {
          return firstHeight + (heightConst * x) + y
        } else {
          return firstHeight + (heightConst * x)
        }
      }
      doc.setFontSize(17)
      doc.text(handleData['No'], currentCertNo, dateHeight)
      doc.setFontSize(11)
      doc.text(CheckWeightSheet['currentDate'], 134 - minusCurrentDate, dateHeight)
      doc.setFontSize(6)
      if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) == 1) {
        doc.text(`st`, 135.7 - minusCurrentDate, currentDateHeight)
      }
      else if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) == 2) {
        doc.text(`nd`, 135.7 - minusCurrentDate, currentDateHeight)
      }
      else if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) == 3) {
        doc.text(`rd`, 135.7 - minusCurrentDate, currentDateHeight)
      }
      else if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) < 10) {
        doc.text(`th`, 135.7 - minusCurrentDate, currentDateHeight)
      }
      else if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) == 21 || parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) == 31) {
        doc.text(`st`, 138 - minusCurrentDate, currentDateHeight)
      }
      else if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) == 22) {
        doc.text(`nd`, 138 - minusCurrentDate, currentDateHeight)
      }
      else if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) == 23) {
        doc.text(`rd`, 138 - minusCurrentDate, currentDateHeight)
      }
      else if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) >= 10) {
        doc.text(`th`, 138 - minusCurrentDate, currentDateHeight)
      }

      doc.setFontSize(11)
      doc.text('WE HEREBY CERTIFY that we inspected the following rice shipment:-', 35, firstHeight - 10)
      let height = 0
      doc.text('Quantity : ', 17.5, getHeight(height))
      doc.text(handleData['bagQuantity'], 70, getHeight(height))
      height += 0.957
      doc.text('Description of goods : ', 17.5, getHeight(height))
      doc.setFontSize(10)
      doc.text(handleData['wtf1'], 70, getHeight(height))
      if (handleData['wtf2']) {
        height += 0.957
        doc.text(handleData['wtf2'], 70, getHeight(height))
        height += 0.957
      }
      doc.setFontSize(11)
      doc.text('Packing : ', 17.5, getHeight(height))
      doc.text(handleData['PackingType1'], 70, getHeight(height))
      height += 0.957
      if (handleData['PackingType11'] !== '-') {
        doc.text(handleData['PackingType11'], 70, getHeight(height))
        height += 0.957
      }
      if (handleData['PackingType12'] !== '-') {
        doc.text(handleData['PackingType12'], 70, getHeight(height))
        height += 0.957
      }

      doc.text(handleData['PackingType2'], 70, getHeight(height))
      height += 0.957
      doc.text('Mark : ', 17.5, getHeight(height))
      doc.text(handleData['logo'], 75, getHeight(height))
      height += 0.957
      doc.text('Shipper : ', 17.5, getHeight(height))
      doc.text(CheckWeightSheet['companyEN'], 70, getHeight(height))
      height += 0.957
      doc.text('Shipper on behalf of :', 17.5, getHeight(height))
      if (`${handleData['ShipperBehalf']}`.indexOf('xxxx') != -1){
        doc.text(handleData['ShipperBehalf'], 75, getHeight(height))
      }else{
        doc.text(handleData['ShipperBehalf'], 70, getHeight(height))
      }
      height += 0.957
      doc.text('Date of loading : ', 17.5, getHeight(height))

      let a1 = parseInt(CheckWeightSheet['shippingDate'].split(" ")[0])
      let a2 = CheckWeightSheet['shippingDate'].split(" ")[1]
      let a3 = CheckWeightSheet['shippingDate'].split(" ")[2]
      doc.text(`${CheckWeightSheet['shippingDate']}`, 70, getHeight(height))
      doc.setFontSize(6)
      if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) == 1) {
        doc.text(`st`, 71.7, getHeight(height, -2))
      }
      else if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) == 2) {
        doc.text(`nd`, 71.7, getHeight(height, -2))
      }
      else if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) == 3) {
        doc.text(`rd`, 71.7, getHeight(height, -2))
      }
      else if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) < 10) {
        doc.text(`th`, 71.7, getHeight(height, -2))
      }
      else if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) == 21 || parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) == 31) {
        doc.text(`st`, 74, getHeight(height, -2))
      }
      else if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) == 22) {
        doc.text(`nd`, 74, getHeight(height, -2))
      }
      else if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) == 23) {
        doc.text(`rd`, 74, getHeight(height, -2))
      }
      else if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) >= 10) {
        doc.text(`th`, 74, getHeight(height, -2))
      }
      height += 0.957
      doc.setFontSize(11)
      doc.text('Place of loading : ', 17.5, getHeight(height))
      doc.text(CheckWeightSheet['godown'], 70, getHeight(height))
      height += 0.957
      doc.text('Shipping port : ', 17.5, getHeight(height))
      doc.text(CheckWeightSheet['shippingPort'], 70, getHeight(height))
      height += 0.957
      doc.text('Carrying vessel : ', 17.5, getHeight(height))

      let vehicleKey = ''
      Object.keys(handleData).map((key) => { if (key.indexOf('vehicleName') != -1) vehicleKey = key })

      doc.setFontSize(10); doc.text(handleData[vehicleKey], 70, getHeight(height)); doc.setFontSize(11);
      height += 0.957
      doc.text('Destination : ', 17.5, getHeight(height))
      doc.text(handleData['destinationCity'], 70, getHeight(height))
      height += 0.957
      doc.text('Quality   :  ', 17.5, getHeight(height))
      let underLineWidth = parseFloat(doc.getTextWidth('Quality'))
      doc.line(17.5, getHeight(height, +1), 17.5 + underLineWidth, getHeight(height, +1))
      doc.text(CheckWeightSheet['Quality1'], 40.5, getHeight(height))
      if (handleData['wtf2']) {
        height += 0.957
        // “
        // console.log('helloworld')
        let t = CheckWeightSheet['Quality2'].indexOf('“')
        t = CheckWeightSheet['Quality2'].slice(0, t)
        t = `${t} “`
        doc.text(t, 17.5, getHeight(height))
        underLineWidth = parseFloat(doc.getTextWidth(handleData['wtf1']))
        let underLineWidth2 = parseFloat(doc.getTextWidth(t))
        doc.setFontSize(10)
        doc.text(handleData['wtf1'], (17.5 + (underLineWidth2)), getHeight(height))
        height += 0.957

        doc.text(`${handleData['wtf2']}”`, (17.5 + (underLineWidth2)), getHeight(height))
        height += 0.957
      }
      else {
        height += 0.957
        doc.text(CheckWeightSheet['Quality2'], 17.5, getHeight(height))
        height += 0.957
      }
      doc.setFontSize(11)


      doc.text('Weight   :   ', 17.5, getHeight(height))
      underLineWidth = parseFloat(doc.getTextWidth('Weight'))
      doc.line(17.5, getHeight(height, +1), 17.5 + underLineWidth, getHeight(height, +1))

      // console.log(CheckWeightSheet['Weight'])
      if (CheckWeightSheet['Weight'].indexOf('bags') != -1 || CheckWeightSheet['Weight'].indexOf('kgs.nett') != -1) {
        doc.text(CheckWeightSheet['Weight'].slice(0, 80), 35, getHeight(height))
        // console.log(CheckWeightSheet['Weight'].slice(80,CheckWeightSheet['Weight'].length-13))
        // console.log(CheckWeightSheet['Weight'].slice(CheckWeightSheet['Weight'].length-17,CheckWeightSheet['Weight'].length))
        doc.text(CheckWeightSheet['Weight'].slice(80, CheckWeightSheet['Weight'].length - 13), 160, getHeight(height), 'center')
        doc.text(CheckWeightSheet['Weight'].slice(CheckWeightSheet['Weight'].length - 13, CheckWeightSheet['Weight'].length), 167, getHeight(height))
        height += 0.957
        doc.text('Total gross :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalGross'])}  kgs.`, 186, getHeight(height), 'right')
        height += 0.957
        doc.text('Total tare :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalTare'])}  kgs.`, 186, getHeight(height), 'right')
        height += 0.957
        doc.text('Total nett :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalNett'])}  kgs.`, 186, getHeight(height), 'right')
        console.log(height)
        height = 23
        doc.text(`Export license No.         ${handleData['License']}`, 19, getHeight(height))
        // now target is 18.1 
        // target is 19.375

        // height += 0.9575
        // doc.text('I have dream that be great cause it be power things I think it could give our power and brave for us. at least it will be power for nex generation people. I think it could give our power and brave for us. at least it will be power for I think it could give our power and brave for us. at least it will be power for', 19, getHeight(height), {maxWidth: 180, align: 'justify'});
        doc.autoPrint()
        doc.output('dataurlnewwindow');
        // doc.save(`030811${handleData['License']}.pdf`)
        //  CheckWeightSheet['Weight'].indexOf('cartons') != -1 
      }
      else if (CheckWeightSheet['Weight'].indexOf('cartons') != -1) {
        doc.text(CheckWeightSheet['Weight'].slice(0, 80), 35, getHeight(height))
        doc.text(CheckWeightSheet['Weight'].slice(80, CheckWeightSheet['Weight'].length - 17), 158, getHeight(height), 'center')
        doc.text(CheckWeightSheet['Weight'].slice(CheckWeightSheet['Weight'].length - 17, CheckWeightSheet['Weight'].length), 163, getHeight(height))
        height += 0.957
        doc.text('Total gross :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalGross'])}  kgs.`, 187, getHeight(height), 'right')
        height += 0.957
        doc.text('Total tare :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalTare'])}  kgs.`, 187, getHeight(height), 'right')
        height += 0.957
        doc.text('Total nett :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalNett'])}  kgs.`, 187, getHeight(height), 'right')
        console.log(height)

        height = 23
        doc.text(`Export license No.         ${handleData['License']}`, 19, getHeight(height))
        doc.autoPrint()
        doc.output('dataurlnewwindow');
        //  CheckWeightSheet['Weight'].indexOf('cartons') != -1 
      }
      else if (CheckWeightSheet['Weight'].indexOf('trays') != -1) {
        doc.text(CheckWeightSheet['Weight'].slice(0, 80), 35, getHeight(height))
        // console.log(CheckWeightSheet['Weight'].slice(80, CheckWeightSheet['Weight'].length - 17))
        doc.text(CheckWeightSheet['Weight'].slice(80, CheckWeightSheet['Weight'].length - 16), 159, getHeight(height), 'center')
        doc.text(CheckWeightSheet['Weight'].slice(CheckWeightSheet['Weight'].length - 16, CheckWeightSheet['Weight'].length), 165, getHeight(height))
        height += 0.957
        doc.text('Total gross :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalGross'])}  kgs.`, 187, getHeight(height), 'right')
        height += 0.957
        doc.text('Total tare :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalTare'])}  kgs.`, 187, getHeight(height), 'right')
        height += 0.957
        doc.text('Total nett :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalNett'])}  kgs.`, 187, getHeight(height), 'right')
        console.log(height)
        height = 23
        doc.text(`Export license No.         ${handleData['License']}`, 19, getHeight(height))
        doc.autoPrint()
        doc.output('dataurlnewwindow');
        //  CheckWeightSheet['Weight'].indexOf('cartons') != -1 
      }
      else if (CheckWeightSheet['Weight'].indexOf('carton') != -1) {
        doc.text(CheckWeightSheet['Weight'].slice(0, 68), 40, getHeight(height))
        doc.text(CheckWeightSheet['Weight'].slice(68, CheckWeightSheet['Weight'].length - 14), 150, getHeight(height))
        doc.text(CheckWeightSheet['Weight'].slice(CheckWeightSheet['Weight'].length - 14, CheckWeightSheet['Weight'].length), 163, getHeight(height))
        height += 0.957
        doc.text('Total gross :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalGross'])}  kgs.`, 186, getHeight(height), 'right')
        height += 0.957
        doc.text('Total tare :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalTare'])}  kgs.`, 186, getHeight(height), 'right')
        height += 0.957
        doc.text('Total nett :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalNett'])}  kgs.`, 186, getHeight(height), 'right')
        height = 23
        doc.text(`Export license No.         ${handleData['License']}`, 19, getHeight(height))
        doc.autoPrint()
        doc.output('dataurlnewwindow');
        //  CheckWeightSheet['Weight'].indexOf('cartons') != -1  
        //CheckWeightSheet['Weight'].indexOf('carton') != -1
      }

      else if (CheckWeightSheet['Weight'].indexOf('pasteboard boxes') != -1) {
        doc.text(CheckWeightSheet['Weight'].slice(0, 68), 40, getHeight(height))
        doc.text(CheckWeightSheet['Weight'].slice(68, CheckWeightSheet['Weight'].length - 23), 146, getHeight(height))
        doc.text(CheckWeightSheet['Weight'].slice(CheckWeightSheet['Weight'].length - 23, CheckWeightSheet['Weight'].length - 6), 158, getHeight(height))
        height += 0.957
        doc.text(CheckWeightSheet['Weight'].slice(CheckWeightSheet['Weight'].length - 6, CheckWeightSheet['Weight'].length), 19, getHeight(height))
        // let a = CheckWeightSheet['Weight'].match(/\d+/g)
        // console.log(a[a.length-1])
        // console.log(CheckWeightSheet['Weight'].indexOf(a[0]))
        // console.log(CheckWeightSheet['Weight'].indexOf(a[1]))
        height += 0.957
        doc.text('Total gross :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalGross'])}  kgs.`, 186, getHeight(height), 'right')
        height += 0.957
        doc.text('Total tare :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalTare'])}  kgs.`, 186, getHeight(height), 'right')
        height += 0.957
        doc.text('Total nett :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalNett'])}  kgs.`, 186, getHeight(height), 'right')
        height = 23
        doc.text(`Export license No.         ${handleData['License']}`, 19, getHeight(height))
        doc.autoPrint()
        doc.output('dataurlnewwindow');
        // doc.save(`030811${handleData['License']}.pdf`)
      }
      else if (CheckWeightSheet['Weight'].indexOf('pasteboard boxes') != -1) {
        doc.text(CheckWeightSheet['Weight'].slice(0, 68), 40, getHeight(height))
        doc.text(CheckWeightSheet['Weight'].slice(68, CheckWeightSheet['Weight'].length - 23), 146, getHeight(height))
        doc.text(CheckWeightSheet['Weight'].slice(CheckWeightSheet['Weight'].length - 23, CheckWeightSheet['Weight'].length - 6), 158, getHeight(height))
        height += 0.957
        doc.text(CheckWeightSheet['Weight'].slice(CheckWeightSheet['Weight'].length - 6, CheckWeightSheet['Weight'].length), 19, getHeight(height))
        // let a = CheckWeightSheet['Weight'].match(/\d+/g)
        // console.log(a[a.length-1])
        // console.log(CheckWeightSheet['Weight'].indexOf(a[0]))
        // console.log(CheckWeightSheet['Weight'].indexOf(a[1]))
        height += 0.957
        doc.text('Total gross :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalGross'])}  kgs.`, 186, getHeight(height), 'right')
        height += 0.957
        doc.text('Total tare :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalTare'])}  kgs.`, 186, getHeight(height), 'right')
        height += 0.957
        doc.text('Total nett :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalNett'])}  kgs.`, 186, getHeight(height), 'right')
        height = 25
        doc.text(`Export license No.         ${handleData['License']}`, 19, getHeight(height))
        doc.autoPrint()
        doc.output('dataurlnewwindow');
        // doc.save(`030811${handleData['License']}.pdf`)
      }
    } else if (handleData['wtf1'] && handleData['PackingType2']) {
      let heightConst = 8
      // console.log(handleData)

      function getHeight(x, y) {
        if (y) {
          return firstHeight + (heightConst * x) + y
        } else {
          return firstHeight + (heightConst * x)
        }
      }
      doc.setFontSize(17)
      doc.text(handleData['No'], currentCertNo, dateHeight)
      doc.setFontSize(11)
      doc.text(CheckWeightSheet['currentDate'], 134 - minusCurrentDate, dateHeight)
      doc.setFontSize(6)
      if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) == 1) {
        doc.text(`st`, 135.7 - minusCurrentDate, currentDateHeight)
      }
      else if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) == 2) {
        doc.text(`nd`, 135.7 - minusCurrentDate, currentDateHeight)
      }
      else if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) == 3) {
        doc.text(`rd`, 135.7 - minusCurrentDate, currentDateHeight)
      }
      else if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) < 10) {
        doc.text(`th`, 135.7 - minusCurrentDate, currentDateHeight)
      }
      else if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) == 21 || parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) == 31) {
        doc.text(`st`, 138 - minusCurrentDate, currentDateHeight)
      }
      else if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) == 22) {
        doc.text(`nd`, 138 - minusCurrentDate, currentDateHeight)
      }
      else if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) == 23) {
        doc.text(`rd`, 138 - minusCurrentDate, currentDateHeight)
      }
      else if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) >= 10) {
        doc.text(`th`, 138 - minusCurrentDate, currentDateHeight)
      }
      doc.setFontSize(11)
      doc.text('WE HEREBY CERTIFY that we inspected the following rice shipment:-', 35, firstHeight - 10)
      let height = 0
      doc.text('Quantity : ', 17.5, getHeight(height))
      doc.text(handleData['bagQuantity'], 70, getHeight(height))
      height += 1.078

      doc.text('Description of goods : ', 17.5, getHeight(height))
      doc.setFontSize(10)
      doc.text(handleData['wtf1'], 70, getHeight(height))
      if (handleData['wtf3']) {
        height += 0.5
        doc.text(handleData['wtf2'], 70, getHeight(height))
        height += 0.5
        if (handleData['wtf3']) {
          doc.text(handleData['wtf3'], 70, getHeight(height))
          height += 0.5
        } else {
          height += 0.5
        }
      }
      else if (handleData['wtf2']) {
        height += 1.078
        doc.text(handleData['wtf2'], 70, getHeight(height))
        height += 1.078
      }
      else {
        height += 1.078
      }
      doc.setFontSize(11)
      doc.text('Packing : ', 17.5, getHeight(height))
      console.log(handleData)
      doc.text(handleData['PackingType1'], 70, getHeight(height))
      height += 1.078
      if (handleData['PackingType11'] !== '-') {
        doc.text(handleData['PackingType11'], 70, getHeight(height))
        height += 1.078
      }
      if (handleData['PackingType12'] !== '-') {
        doc.text(handleData['PackingType12'], 70, getHeight(height))
        height += 1.078
      }

      doc.text(handleData['PackingType2'], 70, getHeight(height))
      height += 1.078
      doc.text('Mark : ', 17.5, getHeight(height))
      doc.text(handleData['logo'], 75, getHeight(height))
      height += 1.078
      doc.text('Shipper : ', 17.5, getHeight(height))
      doc.text(CheckWeightSheet['companyEN'], 70, getHeight(height))
      height += 1.078
      doc.text('Shipper on behalf of :', 17.5, getHeight(height))
      if (`${handleData['ShipperBehalf']}`.indexOf('xxxx') != -1){
        doc.text(handleData['ShipperBehalf'], 75, getHeight(height))
      }else{
        doc.text(handleData['ShipperBehalf'], 70, getHeight(height))
      }
      height += 1.078
      doc.text('Date of loading : ', 17.5, getHeight(height))

      let a1 = parseInt(CheckWeightSheet['shippingDate'].split(" ")[0])
      let a2 = CheckWeightSheet['shippingDate'].split(" ")[1]
      let a3 = CheckWeightSheet['shippingDate'].split(" ")[2]
      doc.text(`${CheckWeightSheet['shippingDate']}`, 70, getHeight(height))
      doc.setFontSize(6)
      if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) == 1) {
        doc.text(`st`, 71.7, getHeight(height, -2))
      }
      else if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) == 2) {
        doc.text(`nd`, 71.7, getHeight(height, -2))
      }
      else if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) == 3) {
        doc.text(`rd`, 71.7, getHeight(height, -2))
      }
      else if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) < 10) {
        doc.text(`th`, 71.7, getHeight(height, -2))
      }
      else if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) == 21 || parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) == 31) {
        doc.text(`st`, 74, getHeight(height, -2))
      }
      else if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) == 22) {
        doc.text(`nd`, 74, getHeight(height, -2))
      }
      else if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) == 23) {
        doc.text(`rd`, 74, getHeight(height, -2))
      }
      else if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) >= 10) {
        doc.text(`th`, 74, getHeight(height, -2))
      }
      height += 1.078
      doc.setFontSize(11)
      // console.log(height)
      doc.text('Place of loading : ', 17.5, getHeight(height))
      doc.text(CheckWeightSheet['godown'], 70, getHeight(height))
      height += 1.078
      // console.log(height)
      doc.text('Shipping port : ', 17.5, getHeight(height))
      doc.text(CheckWeightSheet['shippingPort'], 70, getHeight(height))
      height += 1.078
      // console.log(height)
      doc.text('Carrying vessel : ', 17.5, getHeight(height))

      let vehicleKey = ''
      Object.keys(handleData).map((key) => { if (key.indexOf('vehicleName') != -1) vehicleKey = key })
      // console.log(handleData[vehicleKey], vehicleKey)
      doc.setFontSize(10); doc.text(handleData[vehicleKey], 70, getHeight(height)); doc.setFontSize(11);
      height += 1.078
      doc.text('Destination : ', 17.5, getHeight(height))
      doc.text(handleData['destinationCity'], 70, getHeight(height))
      height += 1.078
      doc.text('Quality   :  ', 17.5, getHeight(height))
      let underLineWidth = parseFloat(doc.getTextWidth('Quality'))
      doc.line(17.5, getHeight(height, +1), 17.5 + underLineWidth, getHeight(height, +1))
      doc.text(CheckWeightSheet['Quality1'], 40.5, getHeight(height))
      if (handleData['wtf3']) {
        height += 0.5
        let t = CheckWeightSheet['Quality2'].indexOf('“')
        t = CheckWeightSheet['Quality2'].slice(0, t)
        t = `${t} “`
        doc.text(t, 17.5, getHeight(height))
        underLineWidth = parseFloat(doc.getTextWidth(handleData['wtf1']))
        let underLineWidth2 = parseFloat(doc.getTextWidth(t))
        doc.setFontSize(10)
        doc.text(handleData['wtf1'], (17.5 + underLineWidth2), getHeight(height))
        height += 0.5
        doc.text(handleData['wtf2'], (17.5 + (underLineWidth2)), getHeight(height))
        height += 0.5
        if (handleData['wtf3']) {
          doc.text(handleData['wtf3'], (17.5 + (underLineWidth2)), getHeight(height))
          height += 0.5
        } else {
          height += 0.5
        }
      } else if (handleData['wtf2']) {
        height += 1.078
        let t = CheckWeightSheet['Quality2'].indexOf('“')
        t = CheckWeightSheet['Quality2'].slice(0, t)
        t = `${t} “${handleData['wtf1']}`
        doc.text(t, 17.5, getHeight(height))
        height += 1.078
        underLineWidth = parseFloat(doc.getTextWidth(handleData['wtf1']))
        let underLineWidth2 = parseFloat(doc.getTextWidth(t))

        doc.text(handleData['wtf2'], (17.5 + (underLineWidth2 - underLineWidth)), getHeight(height))
        height += 1.078
      }
      else {
        doc.setFontSize(11)
        height += 1.078
        let t = CheckWeightSheet['Quality2'].indexOf('“')
        t = CheckWeightSheet['Quality2'].slice(0, t)
        t = `${t} “`
        doc.text(t, 17.5, getHeight(height))
        underLineWidth = parseFloat(doc.getTextWidth(handleData['wtf1']))
        let underLineWidth2 = parseFloat(doc.getTextWidth(t))
        doc.setFontSize(10)
        doc.text(`${handleData['wtf1']}”`, (17.5 + underLineWidth2), getHeight(height))
        height += 1.078
      }
      doc.setFontSize(11)


      doc.text('Weight   :   ', 17.5, getHeight(height))
      underLineWidth = parseFloat(doc.getTextWidth('Weight'))
      doc.line(17.5, getHeight(height, +1), 17.5 + underLineWidth, getHeight(height, +1))

      // console.log(CheckWeightSheet['Weight'])
      if (CheckWeightSheet['Weight'].indexOf('bag') != -1 || CheckWeightSheet['Weight'].indexOf('kgs.nett') != -1) {
        doc.text(CheckWeightSheet['Weight'].slice(0, 80), 35, getHeight(height))
        // console.log('packing 1 without zz')
        // console.log(CheckWeightSheet['Weight'].slice(CheckWeightSheet['Weight'].length-17,CheckWeightSheet['Weight'].length))
        doc.text(CheckWeightSheet['Weight'].slice(80, CheckWeightSheet['Weight'].length - 13), 160, getHeight(height), 'center')
        doc.text(CheckWeightSheet['Weight'].slice(CheckWeightSheet['Weight'].length - 13, CheckWeightSheet['Weight'].length), 167, getHeight(height))
        height += 1.078
        doc.text('Total gross :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalGross'])}  kgs.`, 186, getHeight(height), 'right')
        height += 1.078
        console.log(height)
        doc.text('Total tare :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalTare'])}  kgs.`, 186, getHeight(height), 'right')
        height += 1.078
        console.log(height)
        doc.text('Total nett :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalNett'])}  kgs.`, 186, getHeight(height), 'right')
        height = 23
        doc.text(`Export license No.         ${handleData['License']}`, 19, getHeight(height))
        // height += 1
        // doc.text('I have dream that be great cause it be power things I think it could give our power and brave for us. at least it will be power for nex generation people. I think it could give our power and brave for us. at least it will be power for I think it could give our power and brave for us. at least it will be power for', 19, getHeight(height), {maxWidth: 180, align: 'justify'});
        doc.autoPrint()
        doc.output('dataurlnewwindow');
        // now target is 16.75
        // target is 19.375
        // doc.save(`030811${handleData['License']}.pdf`)
        //  CheckWeightSheet['Weight'].indexOf('cartons') != -1 
      }
      else if (CheckWeightSheet['Weight'].indexOf('cartons') != -1) {
        doc.text(CheckWeightSheet['Weight'].slice(0, 80), 35, getHeight(height))
        doc.text(CheckWeightSheet['Weight'].slice(80, CheckWeightSheet['Weight'].length - 17), 158, getHeight(height), 'center')
        doc.text(CheckWeightSheet['Weight'].slice(CheckWeightSheet['Weight'].length - 17, CheckWeightSheet['Weight'].length), 163, getHeight(height))


        height += 1.078
        doc.text('Total gross :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalGross'])}  kgs.`, 187, getHeight(height), 'right')
        height += 1.078
        doc.text('Total tare :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalTare'])}  kgs.`, 187, getHeight(height), 'right')
        height += 1.078
        doc.text('Total nett :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalNett'])}  kgs.`, 187, getHeight(height), 'right')
        console.log(height)
        height = 23
        doc.text(`Export license No.         ${handleData['License']}`, 19, getHeight(height))
        doc.autoPrint()
        doc.output('dataurlnewwindow');
        //  CheckWeightSheet['Weight'].indexOf('cartons') != -1 
      }
      else if (CheckWeightSheet['Weight'].indexOf('trays') != -1) {
        doc.text(CheckWeightSheet['Weight'].slice(0, 80), 35, getHeight(height))
        // console.log(CheckWeightSheet['Weight'].slice(80, CheckWeightSheet['Weight'].length - 17))
        doc.text(CheckWeightSheet['Weight'].slice(80, CheckWeightSheet['Weight'].length - 16), 159, getHeight(height), 'center')
        doc.text(CheckWeightSheet['Weight'].slice(CheckWeightSheet['Weight'].length - 16, CheckWeightSheet['Weight'].length), 165, getHeight(height))
        height += 1.078
        doc.text('Total gross :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalGross'])}  kgs.`, 187, getHeight(height), 'right')
        height += 1.078
        doc.text('Total tare :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalTare'])}  kgs.`, 187, getHeight(height), 'right')
        height += 1.078
        doc.text('Total nett :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalNett'])}  kgs.`, 187, getHeight(height), 'right')
        console.log(height)
        height = 23
        doc.text(`Export license No.         ${handleData['License']}`, 19, getHeight(height))
        doc.autoPrint()
        doc.output('dataurlnewwindow');
        //  CheckWeightSheet['Weight'].indexOf('cartons') != -1 
      }
      else if (CheckWeightSheet['Weight'].indexOf('carton') != -1) {
        doc.text(CheckWeightSheet['Weight'].slice(0, 68), 40, getHeight(height))
        doc.text(CheckWeightSheet['Weight'].slice(68, CheckWeightSheet['Weight'].length - 14), 150, getHeight(height))
        doc.text(CheckWeightSheet['Weight'].slice(CheckWeightSheet['Weight'].length - 14, CheckWeightSheet['Weight'].length), 163, getHeight(height))
        height += 1.078
        doc.text('Total gross :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalGross'])}  kgs.`, 186, getHeight(height), 'right')
        height += 1.078
        doc.text('Total tare :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalTare'])}  kgs.`, 186, getHeight(height), 'right')
        height += 1.078
        doc.text('Total nett :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalNett'])}  kgs.`, 186, getHeight(height), 'right')
        height = 23
        doc.text(`Export license No.         ${handleData['License']}`, 19, getHeight(height))
        doc.autoPrint()
        doc.output('dataurlnewwindow');
        //  CheckWeightSheet['Weight'].indexOf('cartons') != -1  
        //CheckWeightSheet['Weight'].indexOf('carton') != -1
      }

      else if (CheckWeightSheet['Weight'].indexOf('pasteboard boxes') != -1) {
        doc.text(CheckWeightSheet['Weight'].slice(0, 68), 40, getHeight(height))
        doc.text(CheckWeightSheet['Weight'].slice(68, CheckWeightSheet['Weight'].length - 23), 146, getHeight(height))
        doc.text(CheckWeightSheet['Weight'].slice(CheckWeightSheet['Weight'].length - 23, CheckWeightSheet['Weight'].length - 6), 158, getHeight(height))
        height += 1.078
        doc.text(CheckWeightSheet['Weight'].slice(CheckWeightSheet['Weight'].length - 6, CheckWeightSheet['Weight'].length), 19, getHeight(height))
        // let a = CheckWeightSheet['Weight'].match(/\d+/g)
        // console.log(a[a.length-1])
        // console.log(CheckWeightSheet['Weight'].indexOf(a[0]))
        // console.log(CheckWeightSheet['Weight'].indexOf(a[1]))
        height += 1.078
        doc.text('Total gross :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalGross'])}  kgs.`, 186, getHeight(height), 'right')
        height += 1.078
        doc.text('Total tare :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalTare'])}  kgs.`, 186, getHeight(height), 'right')
        height += 1.078
        doc.text('Total nett :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalNett'])}  kgs.`, 186, getHeight(height), 'right')
        height = 23
        doc.text(`Export license No.         ${handleData['License']}`, 19, getHeight(height))
        doc.autoPrint()
        doc.output('dataurlnewwindow');
        // doc.save(`030811${handleData['License']}.pdf`)
      }
      else if (CheckWeightSheet['Weight'].indexOf('pasteboard boxes') != -1) {
        doc.text(CheckWeightSheet['Weight'].slice(0, 68), 40, getHeight(height))
        doc.text(CheckWeightSheet['Weight'].slice(68, CheckWeightSheet['Weight'].length - 23), 146, getHeight(height))
        doc.text(CheckWeightSheet['Weight'].slice(CheckWeightSheet['Weight'].length - 23, CheckWeightSheet['Weight'].length - 6), 158, getHeight(height))
        height += 1.078
        doc.text(CheckWeightSheet['Weight'].slice(CheckWeightSheet['Weight'].length - 6, CheckWeightSheet['Weight'].length), 19, getHeight(height))
        // let a = CheckWeightSheet['Weight'].match(/\d+/g)
        // console.log(a[a.length-1])
        // console.log(CheckWeightSheet['Weight'].indexOf(a[0]))
        // console.log(CheckWeightSheet['Weight'].indexOf(a[1]))
        height += 1.078
        doc.text('Total gross :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalGross'])}  kgs.`, 186, getHeight(height), 'right')
        height += 1.078
        doc.text('Total tare :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalTare'])}  kgs.`, 186, getHeight(height), 'right')
        height += 1.078
        doc.text('Total nett :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalNett'])}  kgs.`, 186, getHeight(height), 'right')
        height = 23
        doc.text(`Export license No.         ${handleData['License']}`, 19, getHeight(height))
        doc.autoPrint()
        doc.output('dataurlnewwindow');
        // doc.save(`030811${handleData['License']}.pdf`)
      }
    }
    else {
      let heightConst = 8
      // console.log(handleData)

      function getHeight(x, y) {
        if (y) {
          return firstHeight + (heightConst * x) + y
        } else {
          return firstHeight + (heightConst * x)
        }
      }
      doc.setFontSize(17)
      console.log(handleData['No'])
      doc.text(handleData['No'], currentCertNo, dateHeight)
      doc.setFontSize(11)
      console.log(CheckWeightSheet)
      doc.text(CheckWeightSheet['currentDate'], 134 - minusCurrentDate, dateHeight)
      doc.setFontSize(6)
      if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) == 1) {
        doc.text(`st`, 135.7 - minusCurrentDate, currentDateHeight)
      }
      else if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) == 2) {
        doc.text(`nd`, 135.7 - minusCurrentDate, currentDateHeight)
      }
      else if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) == 3) {
        doc.text(`rd`, 135.7 - minusCurrentDate, currentDateHeight)
      }
      else if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) < 10) {
        doc.text(`th`, 135.7 - minusCurrentDate, currentDateHeight)
      }
      else if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) == 21 || parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) == 31) {
        doc.text(`st`, 138 - minusCurrentDate, currentDateHeight)
      }
      else if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) == 22) {
        doc.text(`nd`, 138 - minusCurrentDate, currentDateHeight)
      }
      else if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) == 23) {
        doc.text(`rd`, 138 - minusCurrentDate, currentDateHeight)
      }
      else if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) >= 10) {
        doc.text(`th`, 138 - minusCurrentDate, currentDateHeight)
      }
      console.log(CheckWeightSheet)
      doc.setFontSize(11)
      doc.text('WE HEREBY CERTIFY that we inspected the following rice shipment:-', 35, firstHeight - 10)


      let height = 0
      doc.text('Quantity : ', 17.5, getHeight(height))
      doc.text(handleData['bagQuantity'], 70, getHeight(height))
      height += 1.15
      doc.text('Description of goods : ', 17.5, getHeight(height))
      doc.setFontSize(10)
      console.log(handleData)
      if (handleData['wtf1']) {
        doc.text(handleData['wtf1'], 70, getHeight(height))
      }
      if (handleData['wtf3']) {
        height += 0.5
        doc.text(handleData['wtf2'], 70, getHeight(height))
        height += 0.5
        if (handleData['wtf3']) {
          doc.text(handleData['wtf3'], 70, getHeight(height))
          height += 0.5
        } else {
          height += 0.5
        }
      }
      else if (handleData['wtf2']) {
        height += 1
        doc.text(handleData['wtf2'], 70, getHeight(height))
        height += 1
      }
      else {
        height += 1.15
      }
      doc.setFontSize(11)
      doc.text('Packing : ', 17.5, getHeight(height))
      doc.text(handleData['PackingType1'], 70, getHeight(height))
      height += 1.15
      if (handleData['PackingType11'] !== '-') {
        doc.text(handleData['PackingType11'], 70, getHeight(height))
        height += 1
      }
      if (handleData['PackingType12'] !== '-') {
        doc.text(handleData['PackingType12'], 70, getHeight(height))
        height += 1
      }
      console.log(handleData)

      doc.text('Mark : ', 17.5, getHeight(height))
      doc.text(handleData['logo'], 75, getHeight(height))
      height += 1.15
      doc.text('Shipper : ', 17.5, getHeight(height))
      doc.text(CheckWeightSheet['companyEN'], 70, getHeight(height))
      height += 1.15
      doc.text('Shipper on behalf of :', 17.5, getHeight(height))
      if (`${handleData['ShipperBehalf']}`.indexOf('xxxx') != -1){
        doc.text(handleData['ShipperBehalf'], 75, getHeight(height))
      }else{
        doc.text(handleData['ShipperBehalf'], 70, getHeight(height))
      }
      height += 1.15
      doc.text('Date of loading : ', 17.5, getHeight(height))
      console.log(handleData)

      let a1 = parseInt(CheckWeightSheet['shippingDate'].split(" ")[0])
      let a2 = CheckWeightSheet['shippingDate'].split(" ")[1]
      let a3 = CheckWeightSheet['shippingDate'].split(" ")[2]
      doc.text(`${CheckWeightSheet['shippingDate']}`, 70, getHeight(height))
      doc.setFontSize(6)
      if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) == 1) {
        doc.text(`st`, 71.7, getHeight(height, -2))
      }
      else if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) == 2) {
        doc.text(`nd`, 71.7, getHeight(height, -2))
      }
      else if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) == 3) {
        doc.text(`rd`, 71.7, getHeight(height, -2))
      }
      else if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) < 10) {
        doc.text(`th`, 71.7, getHeight(height, -2))
      }
      else if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) == 21 || parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) == 31) {
        doc.text(`st`, 74, getHeight(height, -2))
      }
      else if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) == 22) {
        doc.text(`nd`, 74, getHeight(height, -2))
      }
      else if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) == 23) {
        doc.text(`rd`, 74, getHeight(height, -2))
      }
      else if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) >= 10) {
        doc.text(`th`, 74, getHeight(height, -2))
      }
      height += 1.15
      doc.setFontSize(11)
      doc.text('Place of loading : ', 17.5, getHeight(height))
      doc.text(CheckWeightSheet['godown'], 70, getHeight(height))
      height += 1.15
      doc.text('Shipping port : ', 17.5, getHeight(height))
      doc.text(CheckWeightSheet['shippingPort'], 70, getHeight(height))
      height += 1.15

      doc.text('Carrying vessel : ', 17.5, getHeight(height))
      console.log(handleData)

      let vehicleKey = ''
      Object.keys(handleData).map((key) => { if (key.indexOf('vehicleName') != -1) vehicleKey = key })
      // console.log(handleData[vehicleKey], vehicleKey)
      doc.setFontSize(10); doc.text(handleData[vehicleKey], 70, getHeight(height)); doc.setFontSize(11);
      height += 1.15
      doc.text('Destination : ', 17.5, getHeight(height))
      doc.text(handleData['destinationCity'], 70, getHeight(height))
      height += 1.15
      doc.text('Quality   :  ', 17.5, getHeight(height))
      let underLineWidth = parseFloat(doc.getTextWidth('Quality'))
      doc.line(17.5, getHeight(height, +1), 17.5 + underLineWidth, getHeight(height, +1))
      doc.text(CheckWeightSheet['Quality1'], 40.5, getHeight(height))
      console.log(handleData)

      if (handleData['wtf3']) {
        height += 0.5
        let t = CheckWeightSheet['Quality2'].indexOf('“')
        t = CheckWeightSheet['Quality2'].slice(0, t)
        t = `${t} “`
        doc.text(t, 17.5, getHeight(height))

        underLineWidth = parseFloat(doc.getTextWidth(handleData['wtf1']))
        let underLineWidth2 = parseFloat(doc.getTextWidth(t))
        doc.setFontSize(10)
        doc.text(handleData['wtf1'], (17.5 + underLineWidth2), getHeight(height))

        height += 0.5

        doc.text(handleData['wtf2'], (17.5 + (underLineWidth2)), getHeight(height))
        height += 0.5
        if (handleData['wtf3']) {
          doc.text(handleData['wtf3'], (17.5 + (underLineWidth2)), getHeight(height))
          height += 0.5
        } else {
          height += 0.5
        }
      } else {
        doc.setFontSize(11)
        height += 1.15
        let t = CheckWeightSheet['Quality2'].indexOf('“')
        t = CheckWeightSheet['Quality2'].slice(0, t)
        t = `${t} “`
        doc.text(t, 17.5, getHeight(height))
        underLineWidth = parseFloat(doc.getTextWidth(handleData['wtf1']))
        let underLineWidth2 = parseFloat(doc.getTextWidth(t))
        doc.setFontSize(10)
        doc.text(`${handleData['wtf1']}”`, (17.5 + underLineWidth2), getHeight(height))
        height += 1.15
      }
      doc.setFontSize(11)
      console.log(handleData)


      doc.text('Weight   :   ', 17.5, getHeight(height))
      underLineWidth = parseFloat(doc.getTextWidth('Weight'))
      doc.line(17.5, getHeight(height, +1), 17.5 + underLineWidth, getHeight(height, +1))

      console.log(handleData)
      // console.log(CheckWeightSheet['Weight'])
      if (CheckWeightSheet['Weight'].indexOf('bag') != -1 || CheckWeightSheet['Weight'].indexOf('kgs.nett') != -1) {
        doc.text(CheckWeightSheet['Weight'].slice(0, 80), 35, getHeight(height))
        // console.log(CheckWeightSheet['Weight'].slice(80,CheckWeightSheet['Weight'].length-13))
        // console.log(CheckWeightSheet['Weight'].slice(CheckWeightSheet['Weight'].length-17,CheckWeightSheet['Weight'].length))
        doc.text(CheckWeightSheet['Weight'].slice(80, CheckWeightSheet['Weight'].length - 13), 160, getHeight(height), 'center')
        doc.text(CheckWeightSheet['Weight'].slice(CheckWeightSheet['Weight'].length - 13, CheckWeightSheet['Weight'].length), 167, getHeight(height))
        height += 1.15
        doc.text('Total gross :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalGross'])}  kgs.`, 186, getHeight(height), 'right')
        height += 1.15
        doc.text('Total tare :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalTare'])}  kgs.`, 186, getHeight(height), 'right')
        height += 1.15
        console.log(height)
        doc.text('Total nett :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalNett'])}  kgs.`, 186, getHeight(height), 'right')
        height = 23
        doc.text(`Export license No.         ${handleData['License']}`, 19, getHeight(height))
        // height += 1
        // doc.text('I have dream that be great cause it be power things I think it could give our power and brave for us. at least it will be power for nex generation people. I think it could give our power and brave for us. at least it will be power for I think it could give our power and brave for us. at least it will be power for', 19, getHeight(height), {maxWidth: 180, align: 'justify'});
        doc.autoPrint()
        doc.output('dataurlnewwindow');
        // doc.save(`030811${handleData['License']}.pdf`)
        //  CheckWeightSheet['Weight'].indexOf('cartons') != -1 
      }
      else if (CheckWeightSheet['Weight'].indexOf('test') != -1) {
        doc.text(CheckWeightSheet['Weight'].slice(0, 80), 35, getHeight(height))
        // console.log(CheckWeightSheet['Weight'].slice(80,CheckWeightSheet['Weight'].length-13))
        // console.log(CheckWeightSheet['Weight'].slice(CheckWeightSheet['Weight'].length-17,CheckWeightSheet['Weight'].length))
        doc.text(CheckWeightSheet['Weight'].slice(80, CheckWeightSheet['Weight'].length - 13), 160, getHeight(height), 'center')
        doc.text(CheckWeightSheet['Weight'].slice(CheckWeightSheet['Weight'].length - 13, CheckWeightSheet['Weight'].length), 167, getHeight(height))
        height += 1.15
        doc.text('Total gross :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalGross'])}  kgs.`, 186, getHeight(height), 'right')
        height += 1.15
        doc.text('Total tare :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalTare'])}  kgs.`, 186, getHeight(height), 'right')
        height += 1.15
        console.log(`real final = ${height}`)
        doc.text('Total nett :', 37, getHeight(height))
        doc.text(`${addCommaInNumber(handleData['TotalNett'])}  kgs.`, 186, getHeight(height), 'right')


        // now target is 16.75
        // target is 19.375

        // height += 1.05
        // doc.text('Total nett :', 37, getHeight(height))
        // doc.text(`${addCommaInNumber(handleData['TotalNett'])}  kgs.`, 186, getHeight(height), 'right')
        // height += 1.05
        // console.log(`final is = ${height}`)
        // doc.text('Total nett :', 37, getHeight(height))
        // doc.text(`${addCommaInNumber(handleData['TotalNett'])}  kgs.`, 186, getHeight(height), 'right')


        // height += 1.05
        // console.log(`before final is = ${height}`)
        // doc.text('Total nett :', 37, getHeight(height))
        // doc.text(`${addCommaInNumber(handleData['TotalNett'])}  kgs.`, 186, getHeight(height), 'right')
        // height += 1.05
        // console.log(`final is = ${height}`)
        // doc.text('Total nett :', 37, getHeight(height))
        // doc.text(`${addCommaInNumber(handleData['TotalNett'])}  kgs.`, 186, getHeight(height), 'right')



        height = 23
        doc.text(`Export license No.         ${handleData['License']}`, 19, getHeight(height))
        // height += 1
        // doc.text('I have dream that be great cause it be power things I think it could give our power and brave for us. at least it will be power for nex generation people. I think it could give our power and brave for us. at least it will be power for I think it could give our power and brave for us. at least it will be power for', 19, getHeight(height), {maxWidth: 180, align: 'justify'});
        doc.autoPrint()
        doc.output('dataurlnewwindow');
        // doc.save(`030811${handleData['License']}.pdf`)
        //  CheckWeightSheet['Weight'].indexOf('cartons') != -1 
      }
    }
  }
  renderRedirectToJob() {
    if (this.state.redirect) {
      // this.props.history.location.state
      this.props.history.push({
        pathname: '/CertificateTable',
        state: {
          ...this.props.location.state.shippingDate,
          timeValue: this.props.location.timeValue,
          timeShow: this.props.location.timeShow,
          currentDate: this.props.location.currentDate,
          minusHeight: this.props.location.minusHeight,
          yPosition: this.props.location.yPosition,
          minusCurrentDate: this.props.location.minusCurrentDate,
          minusCertNo: this.props.location.minusCertNo,
        },
      })
    }
  }
  createCertificate(idx, generalDescription) {
    let prepareData = {}
    const arr = ['currentDate', 'shippingDate', 'godown', 'shippingPort', 'Quality1', 'Quality2', 'Weight', 'title1', 'companyEN']
    const arrDes = ['No', 'bagQuantity', 'riceTypeID', 'PackingType1', 'PackingType11', 'PackingType12', 'PackingType2', 'logo', 'ShipperBehalf', 'destinationCity', 'vehicleName', 'TotalGross', 'TotalTare', 'TotalNett', 'License']
    arr.map((title) => {
      prepareData[title] = generalDescription[title]
    })
    arrDes.map((title) => {
      prepareData[title] = generalDescription['description'][idx][title]
    })
    prepareData['jobID'] = generalDescription['jobID']
    prepareData['License'] = `030811${prepareData['License']}`
    prepareData['subID'] = `${idx}`

    axios.post(
      'https://us-central1-riceinspection-16b06.cloudfunctions.net/middleWare',
      {
        action: 'createCertificateSheet',
        data: prepareData,
      }
    ).then((res) => {
      if (res.data) {
        if (res.data.status == 'new') {
          alert('เพิ่มข้อมูลสำเร็จ')
          let doc = new jsPDF('p', 'mm', [840.51, 595.40])

          // doc.addImage(image, 'JPEG', 0, 0, 210, 297);
          // doc.save('test.pdf')
          doc.setFont('Times', 'Roman')
          doc.setFontSize(11)
          let handleData = generalDescription.description[idx]
          let CheckWeightSheet = generalDescription
          let firstHeight = 78
          let heightConst = 8
          function getHeight(x, y) {
            if (y) {
              return firstHeight + (heightConst * x) + y
            } else {
              return firstHeight + (heightConst * x)
            }
          }
          doc.setFontSize(14)
          doc.text(handleData['No'], 29, 59.5)
          doc.setFontSize(11)
          doc.text(CheckWeightSheet['currentDate'], 133, 59.5)
          doc.setFontSize(6)
          if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) == 1) {
            doc.text(`st`, 134.7, 57.5)
          }
          else if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) == 2) {
            doc.text(`nd`, 134.7, 57.5)
          }
          else if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) == 3) {
            doc.text(`rd`, 134.7, 57.5)
          }
          else if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) < 10) {
            doc.text(`th`, 134.7, 57.5)
          }
          else if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) == 21 || parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) == 31) {
            doc.text(`st`, 137, 57.5)
          }
          else if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) == 22) {
            doc.text(`nd`, 137, 57.5)
          }
          else if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) == 23) {
            doc.text(`rd`, 137, 57.5)
          }
          else if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) >= 10) {
            doc.text(`th`, 137, 57.5)
          }
          doc.setFontSize(11)
          doc.text('WE HEREBY CERTIFY that we inspected the following rice shipment:-', 35, firstHeight - 10)
          doc.text('Quantity : ', 19, firstHeight)
          doc.text(handleData['bagQuantity'], 70, firstHeight)
          let height = 1
          doc.text('Description of goods : ', 19, getHeight(height))
          doc.text(handleData['riceTypeID'], 70, getHeight(height))
          height += 1
          doc.text('Packing : ', 19, getHeight(height))
          doc.text(handleData['PackingType1'], 70, getHeight(height))
          height += 1
          if (handleData['PackingType11'] !== '-') {
            doc.text(handleData['PackingType11'], 70, getHeight(height))
            height += 1
          }
          if (handleData['PackingType12'] !== '-') {
            doc.text(handleData['PackingType12'], 70, getHeight(height))
            height += 1
          }

          doc.text(handleData['PackingType2'], 70, getHeight(height))
          height += 1
          doc.text('Mark : ', 19, getHeight(height))
          doc.text(handleData['logo'], 75, getHeight(height))
          height += 1
          doc.text('Shipper : ', 19, getHeight(height))
          doc.text(CheckWeightSheet['companyEN'], 70, getHeight(height))
          height += 1
          doc.text('Shipper on behalf of :', 19, getHeight(height))
          doc.text(handleData['ShipperBehalf'], 75, getHeight(height))
          height += 1
          doc.text('Date of loading : ', 19, getHeight(height))

          let a1 = parseInt(CheckWeightSheet['shippingDate'].split(" ")[0])
          let a2 = CheckWeightSheet['shippingDate'].split(" ")[1]
          let a3 = CheckWeightSheet['shippingDate'].split(" ")[2]
          doc.text(`${CheckWeightSheet['shippingDate']}`, 70, getHeight(height))
          doc.setFontSize(6)
          if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) == 1) {
            doc.text(`st`, 71.7, getHeight(height, -2))
          }
          else if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) == 2) {
            doc.text(`nd`, 71.7, getHeight(height, -2))
          }
          else if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) == 3) {
            doc.text(`rd`, 71.7, getHeight(height, -2))
          }
          else if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) < 10) {
            doc.text(`th`, 71.7, getHeight(height, -2))
          }
          else if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) == 21 || parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) == 31) {
            doc.text(`st`, 74, getHeight(height, -2))
          }
          else if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) == 22) {
            doc.text(`nd`, 74, getHeight(height, -2))
          }
          else if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) == 23) {
            doc.text(`rd`, 74, getHeight(height, -2))
          }
          else if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) >= 10) {
            doc.text(`th`, 74, getHeight(height, -2))
          }
          height += 1
          doc.setFontSize(11)
          doc.text('Place of loading : ', 19, getHeight(height))
          doc.text(CheckWeightSheet['godown'], 70, getHeight(height))
          height += 1
          doc.text('Shipping port : ', 19, getHeight(height))
          doc.text(CheckWeightSheet['shippingPort'], 70, getHeight(height))
          height += 1
          doc.text('Carrying vessel : ', 19, getHeight(height))
          doc.text(handleData['vehicleName'], 70, getHeight(height))
          height += 1
          doc.text('Destination : ', 19, getHeight(height))
          doc.text(handleData['destinationCity'], 70, getHeight(height))
          height += 1
          doc.text('Quality      :  ', 19, getHeight(height))
          let underLineWidth = parseFloat(doc.getTextWidth('Quality'))
          doc.line(19, getHeight(height, +1), 19 + underLineWidth, getHeight(height, +1))
          doc.text(CheckWeightSheet['Quality1'], 42, getHeight(height))
          height += 1
          doc.text(CheckWeightSheet['Quality2'], 21, getHeight(height))
          height += 1
          doc.text('Weight     : ', 19, getHeight(height))
          underLineWidth = parseFloat(doc.getTextWidth('Weight'))
          doc.line(19, getHeight(height, +1), 19 + underLineWidth, getHeight(height, +1))

          // doc.text(CheckWeightSheet['Weight'],54,getHeight(14))
          if (CheckWeightSheet['Weight'].indexOf('bag') != -1 || CheckWeightSheet['Weight'].indexOf('bulk') != -1) {
            doc.text(CheckWeightSheet['Weight'].slice(0, 68), 40, getHeight(height))
            doc.text(CheckWeightSheet['Weight'].slice(68, CheckWeightSheet['Weight'].length - 12), 150, getHeight(height))
            doc.text(CheckWeightSheet['Weight'].slice(CheckWeightSheet['Weight'].length - 12, CheckWeightSheet['Weight'].length), 167, getHeight(height))
            height += 1
            doc.text('Total gross :', 37, getHeight(height))
            doc.text(`${addCommaInNumber(handleData['TotalGross'])}  kgs.`, 185, getHeight(height), 'right')
            height += 1
            doc.text('Total tare :', 37, getHeight(height))
            doc.text(`${addCommaInNumber(handleData['TotalTare'])}  kgs.`, 185, getHeight(height), 'right')
            height += 1
            doc.text('Total nett :', 37, getHeight(height))
            doc.text(`${addCommaInNumber(handleData['TotalNett'])}  kgs.`, 185, getHeight(height), 'right')
            height = 25
            doc.text(`Export license No.         ${handleData['License']}`, 19, getHeight(height))
            // height += 1
            // doc.text('I have dream that be great cause it be power things I think it could give our power and brave for us. at least it will be power for nex generation people. I think it could give our power and brave for us. at least it will be power for I think it could give our power and brave for us. at least it will be power for', 19, getHeight(height), {maxWidth: 180, align: 'justify'});

            doc.save(`030811${handleData['License']}.pdf`)
            //  CheckWeightSheet['Weight'].indexOf('cartons') != -1 
          }
          else if (CheckWeightSheet['Weight'].indexOf('cartons') != -1) {
            doc.text(CheckWeightSheet['Weight'].slice(0, 68), 40, getHeight(height))
            doc.text(CheckWeightSheet['Weight'].slice(68, CheckWeightSheet['Weight'].length - 15), 150, getHeight(height))
            doc.text(CheckWeightSheet['Weight'].slice(CheckWeightSheet['Weight'].length - 15, CheckWeightSheet['Weight'].length), 163, getHeight(height))
            height += 1
            doc.text('Total gross :', 37, getHeight(height))
            doc.text(`${addCommaInNumber(handleData['TotalGross'])}  kgs.`, 185, getHeight(height), 'right')
            height += 1
            doc.text('Total tare :', 37, getHeight(height))
            doc.text(`${addCommaInNumber(handleData['TotalTare'])}  kgs.`, 185, getHeight(height), 'right')
            height += 1
            doc.text('Total nett :', 37, getHeight(height))
            doc.text(`${addCommaInNumber(handleData['TotalNett'])}  kgs.`, 185, getHeight(height), 'right')
            height = 25
            doc.text(`Export license No.         ${handleData['License']}`, 19, getHeight(height))
            doc.save(`030811${handleData['License']}.pdf`)
            //  CheckWeightSheet['Weight'].indexOf('cartons') != -1 
          }
          else if (CheckWeightSheet['Weight'].indexOf('carton') != -1) {
            doc.text(CheckWeightSheet['Weight'].slice(0, 68), 40, getHeight(height))
            doc.text(CheckWeightSheet['Weight'].slice(68, CheckWeightSheet['Weight'].length - 14), 150, getHeight(height))
            doc.text(CheckWeightSheet['Weight'].slice(CheckWeightSheet['Weight'].length - 14, CheckWeightSheet['Weight'].length), 163, getHeight(height))
            height += 1
            doc.text('Total gross :', 37, getHeight(height))
            doc.text(`${addCommaInNumber(handleData['TotalGross'])}  kgs.`, 185, getHeight(height), 'right')
            height += 1
            doc.text('Total tare :', 37, getHeight(height))
            doc.text(`${addCommaInNumber(handleData['TotalTare'])}  kgs.`, 185, getHeight(height), 'right')
            height += 1
            doc.text('Total nett :', 37, getHeight(height))
            doc.text(`${addCommaInNumber(handleData['TotalNett'])}  kgs.`, 185, getHeight(height), 'right')
            height = 25
            doc.text(`Export license No.         ${handleData['License']}`, 19, getHeight(height))
            doc.save(`030811${handleData['License']}.pdf`)
            //  CheckWeightSheet['Weight'].indexOf('cartons') != -1  
            //CheckWeightSheet['Weight'].indexOf('carton') != -1
          }

          else if (CheckWeightSheet['Weight'].indexOf('pasteboard boxes') != -1) {
            doc.text(CheckWeightSheet['Weight'].slice(0, 68), 40, getHeight(height))
            doc.text(CheckWeightSheet['Weight'].slice(68, CheckWeightSheet['Weight'].length - 23), 146, getHeight(height))
            doc.text(CheckWeightSheet['Weight'].slice(CheckWeightSheet['Weight'].length - 23, CheckWeightSheet['Weight'].length - 6), 158, getHeight(height))
            height += 1
            doc.text(CheckWeightSheet['Weight'].slice(CheckWeightSheet['Weight'].length - 6, CheckWeightSheet['Weight'].length), 19, getHeight(height))
            // let a = CheckWeightSheet['Weight'].match(/\d+/g)
            // console.log(a[a.length-1])
            // console.log(CheckWeightSheet['Weight'].indexOf(a[0]))
            // console.log(CheckWeightSheet['Weight'].indexOf(a[1]))
            height += 1
            doc.text('Total gross :', 37, getHeight(height))
            doc.text(`${addCommaInNumber(handleData['TotalGross'])}  kgs.`, 185, getHeight(height), 'right')
            height += 1
            doc.text('Total tare :', 37, getHeight(height))
            doc.text(`${addCommaInNumber(handleData['TotalTare'])}  kgs.`, 185, getHeight(height), 'right')
            height += 1
            doc.text('Total nett :', 37, getHeight(height))
            doc.text(`${addCommaInNumber(handleData['TotalNett'])}  kgs.`, 185, getHeight(height), 'right')
            height = 25
            doc.text(`Export license No.         ${handleData['License']}`, 19, getHeight(height))
            doc.save(`030811${handleData['License']}.pdf`)
          }
          else if (CheckWeightSheet['Weight'].indexOf('pasteboard boxes') != -1) {
            doc.text(CheckWeightSheet['Weight'].slice(0, 68), 40, getHeight(height))
            doc.text(CheckWeightSheet['Weight'].slice(68, CheckWeightSheet['Weight'].length - 23), 146, getHeight(height))
            doc.text(CheckWeightSheet['Weight'].slice(CheckWeightSheet['Weight'].length - 23, CheckWeightSheet['Weight'].length - 6), 158, getHeight(height))
            height += 1
            doc.text(CheckWeightSheet['Weight'].slice(CheckWeightSheet['Weight'].length - 6, CheckWeightSheet['Weight'].length), 19, getHeight(height))
            // let a = CheckWeightSheet['Weight'].match(/\d+/g)
            // console.log(a[a.length-1])
            // console.log(CheckWeightSheet['Weight'].indexOf(a[0]))
            // console.log(CheckWeightSheet['Weight'].indexOf(a[1]))
            height += 1
            doc.text('Total gross :', 37, getHeight(height))
            doc.text(`${addCommaInNumber(handleData['TotalGross'])}  kgs.`, 185, getHeight(height), 'right')
            height += 1
            doc.text('Total tare :', 37, getHeight(height))
            doc.text(`${addCommaInNumber(handleData['TotalTare'])}  kgs.`, 185, getHeight(height), 'right')
            height += 1
            doc.text('Total nett :', 37, getHeight(height))
            doc.text(`${addCommaInNumber(handleData['TotalNett'])}  kgs.`, 185, getHeight(height), 'right')
            height = 25
            doc.text(`Export license No.         ${handleData['License']}`, 19, getHeight(height))
            doc.save(`030811${handleData['License']}.pdf`)
          }
        } else {
          alert('แก้ไขข้อมูลสำเร็จ')
          let doc = new jsPDF('p', 'mm', [840.51, 595.40])

          // doc.addImage(image, 'JPEG', 0, 0, 210, 297);
          // doc.save('test.pdf')
          doc.setFont('Times', 'Roman')
          doc.setFontSize(11)
          let handleData = generalDescription.description[idx]
          let CheckWeightSheet = generalDescription
          let firstHeight = 78
          let heightConst = 8
          function getHeight(x, y) {
            if (y) {
              return firstHeight + (heightConst * x) + y
            } else {
              return firstHeight + (heightConst * x)
            }
          }
          doc.setFontSize(14)
          doc.text(handleData['No'], 29, 59.5)
          doc.setFontSize(11)
          doc.text(CheckWeightSheet['currentDate'], 133, 59.5)
          doc.setFontSize(6)
          if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) == 1) {
            doc.text(`st`, 134.7, 57.5)
          }
          else if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) == 2) {
            doc.text(`nd`, 134.7, 57.5)
          }
          else if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) == 3) {
            doc.text(`rd`, 134.7, 57.5)
          }
          else if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) < 10) {
            doc.text(`th`, 134.7, 57.5)
          }
          else if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) == 21 || parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) == 31) {
            doc.text(`st`, 137, 57.5)
          }
          else if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) == 22) {
            doc.text(`nd`, 137, 57.5)
          }
          else if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) == 23) {
            doc.text(`rd`, 137, 57.5)
          }
          else if (parseInt(CheckWeightSheet['currentDate'].split(" ")[0]) >= 10) {
            doc.text(`th`, 137, 57.5)
          }
          doc.setFontSize(11)
          doc.text('WE HEREBY CERTIFY that we inspected the following rice shipment:-', 35, firstHeight - 10)
          doc.text('Quantity : ', 19, firstHeight)
          doc.text(handleData['bagQuantity'], 70, firstHeight)
          let height = 1
          doc.text('Description of goods : ', 19, getHeight(height))
          doc.text(handleData['riceTypeID'], 70, getHeight(height))
          height += 1
          doc.text('Packing : ', 19, getHeight(height))
          doc.text(handleData['PackingType1'], 70, getHeight(height))
          height += 1
          if (handleData['PackingType11'] !== '-') {
            doc.text(handleData['PackingType11'], 70, getHeight(height))
            height += 1
          }
          if (handleData['PackingType12'] !== '-') {
            doc.text(handleData['PackingType12'], 70, getHeight(height))
            height += 1
          }

          doc.text(handleData['PackingType2'], 70, getHeight(height))
          height += 1
          doc.text('Mark : ', 19, getHeight(height))
          doc.text(handleData['logo'], 75, getHeight(height))
          height += 1
          doc.text('Shipper : ', 19, getHeight(height))
          doc.text(CheckWeightSheet['companyEN'], 70, getHeight(height))
          height += 1
          doc.text('Shipper on behalf of :', 19, getHeight(height))
          doc.text(handleData['ShipperBehalf'], 75, getHeight(height))
          height += 1
          doc.text('Date of loading : ', 19, getHeight(height))

          let a1 = parseInt(CheckWeightSheet['shippingDate'].split(" ")[0])
          let a2 = CheckWeightSheet['shippingDate'].split(" ")[1]
          let a3 = CheckWeightSheet['shippingDate'].split(" ")[2]
          doc.text(`${CheckWeightSheet['shippingDate']}`, 70, getHeight(height))
          doc.setFontSize(6)
          if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) == 1) {
            doc.text(`st`, 71.7, getHeight(height, -2))
          }
          else if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) == 2) {
            doc.text(`nd`, 71.7, getHeight(height, -2))
          }
          else if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) == 3) {
            doc.text(`rd`, 71.7, getHeight(height, -2))
          }
          else if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) < 10) {
            doc.text(`th`, 71.7, getHeight(height, -2))
          }
          else if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) == 21 || parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) == 31) {
            doc.text(`st`, 74, getHeight(height, -2))
          }
          else if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) == 22) {
            doc.text(`nd`, 74, getHeight(height, -2))
          }
          else if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) == 23) {
            doc.text(`rd`, 74, getHeight(height, -2))
          }
          else if (parseInt(CheckWeightSheet['shippingDate'].split(" ")[0]) >= 10) {
            doc.text(`th`, 74, getHeight(height, -2))
          }
          height += 1
          doc.setFontSize(11)
          doc.text('Place of loading : ', 19, getHeight(height))
          doc.text(CheckWeightSheet['godown'], 70, getHeight(height))
          height += 1
          doc.text('Shipping port : ', 19, getHeight(height))
          doc.text(CheckWeightSheet['shippingPort'], 70, getHeight(height))
          height += 1
          doc.text('Carrying vessel : ', 19, getHeight(height))
          doc.text(handleData['vehicleName'], 70, getHeight(height))
          height += 1
          doc.text('Destination : ', 19, getHeight(height))
          doc.text(handleData['destinationCity'], 70, getHeight(height))
          height += 1
          doc.text('Quality      :  ', 19, getHeight(height))
          let underLineWidth = parseFloat(doc.getTextWidth('Quality'))
          doc.line(19, getHeight(height, +1), 19 + underLineWidth, getHeight(height, +1))
          doc.text(CheckWeightSheet['Quality1'], 40, getHeight(height))
          height += 1
          doc.text(CheckWeightSheet['Quality2'], 19, getHeight(height))
          height += 1
          doc.text('Weight     : ', 19, getHeight(height))
          underLineWidth = parseFloat(doc.getTextWidth('Weight'))
          doc.line(19, getHeight(height, +1), 19 + underLineWidth, getHeight(height, +1))

          // doc.text(CheckWeightSheet['Weight'],54,getHeight(14))
          if (CheckWeightSheet['Weight'].indexOf('bag') != -1 || CheckWeightSheet['Weight'].indexOf('bulk') != -1) {
            console.log('bag')
            doc.text(CheckWeightSheet['Weight'].slice(0, 68), 40, getHeight(height))
            doc.text(CheckWeightSheet['Weight'].slice(68, CheckWeightSheet['Weight'].length - 12), 150, getHeight(height))
            doc.text(CheckWeightSheet['Weight'].slice(CheckWeightSheet['Weight'].length - 12, CheckWeightSheet['Weight'].length), 167, getHeight(height))
            height += 1
            doc.text('Total gross :', 37, getHeight(height))
            doc.text(`${addCommaInNumber(handleData['TotalGross'])}  kgs.`, 185, getHeight(height), 'right')
            height += 1
            doc.text('Total tare :', 37, getHeight(height))
            doc.text(`${addCommaInNumber(handleData['TotalTare'])}  kgs.`, 185, getHeight(height), 'right')
            height += 1
            doc.text('Total nett :', 37, getHeight(height))
            doc.text(`${addCommaInNumber(handleData['TotalNett'])}  kgs.`, 185, getHeight(height), 'right')
            height = 25
            doc.text(`Export license No.         ${handleData['License']}`, 19, getHeight(height))
            // height += 1
            // doc.text('I have dream that be great cause it be power things I think it could give our power and brave for us. at least it will be power for nex generation people. I think it could give our power and brave for us. at least it will be power for I think it could give our power and brave for us. at least it will be power for', 19, getHeight(height), {maxWidth: 180, align: 'justify'});

            doc.save(`030811${handleData['License']}.pdf`)
            //  CheckWeightSheet['Weight'].indexOf('cartons') != -1 
          }
          else if (CheckWeightSheet['Weight'].indexOf('cartons') != -1) {
            console.log('cartons')
            doc.text(CheckWeightSheet['Weight'].slice(0, 68), 40, getHeight(height))
            doc.text(CheckWeightSheet['Weight'].slice(68, CheckWeightSheet['Weight'].length - 15), 150, getHeight(height))
            doc.text(CheckWeightSheet['Weight'].slice(CheckWeightSheet['Weight'].length - 15, CheckWeightSheet['Weight'].length), 163, getHeight(height))
            height += 1
            doc.text('Total gross :', 37, getHeight(height))
            doc.text(`${addCommaInNumber(handleData['TotalGross'])}  kgs.`, 190, getHeight(height), 'right')
            height += 1
            doc.text('Total tare :', 37, getHeight(height))
            doc.text(`${addCommaInNumber(handleData['TotalTare'])}  kgs.`, 190, getHeight(height), 'right')
            height += 1
            doc.text('Total nett :', 37, getHeight(height))
            doc.text(`${addCommaInNumber(handleData['TotalNett'])}  kgs.`, 190, getHeight(height), 'right')
            height = 25
            doc.text(`Export license No.         ${handleData['License']}`, 19, getHeight(height))
            doc.save(`030811${handleData['License']}.pdf`)
            //  CheckWeightSheet['Weight'].indexOf('cartons') != -1  
          }
          else if (CheckWeightSheet['Weight'].indexOf('carton') != -1) {
            console.log('carton')
            doc.text(CheckWeightSheet['Weight'].slice(0, 68), 40, getHeight(height))
            doc.text(CheckWeightSheet['Weight'].slice(68, CheckWeightSheet['Weight'].length - 14), 150, getHeight(height))
            doc.text(CheckWeightSheet['Weight'].slice(CheckWeightSheet['Weight'].length - 14, CheckWeightSheet['Weight'].length), 163, getHeight(height))
            height += 1
            doc.text('Total gross :', 37, getHeight(height))
            doc.text(`${addCommaInNumber(handleData['TotalGross'])}  kgs.`, 185, getHeight(height), 'right')
            height += 1
            doc.text('Total tare :', 37, getHeight(height))
            doc.text(`${addCommaInNumber(handleData['TotalTare'])}  kgs.`, 185, getHeight(height), 'right')
            height += 1
            doc.text('Total nett :', 37, getHeight(height))
            doc.text(`${addCommaInNumber(handleData['TotalNett'])}  kgs.`, 185, getHeight(height), 'right')
            height = 25
            doc.text(`Export license No.         ${handleData['License']}`, 19, getHeight(height))
            doc.save(`030811${handleData['License']}.pdf`)
            //  CheckWeightSheet['Weight'].indexOf('cartons') != -1  
            //CheckWeightSheet['Weight'].indexOf('carton') != -1
          }
          else if (CheckWeightSheet['Weight'].indexOf('pasteboard boxes') != -1) {
            console.log('pasteboard')
            doc.text(CheckWeightSheet['Weight'].slice(0, 68), 40, getHeight(height))
            doc.text(CheckWeightSheet['Weight'].slice(68, CheckWeightSheet['Weight'].length - 23), 146, getHeight(height))
            doc.text(CheckWeightSheet['Weight'].slice(CheckWeightSheet['Weight'].length - 23, CheckWeightSheet['Weight'].length - 6), 158, getHeight(height))
            height += 1
            doc.text(CheckWeightSheet['Weight'].slice(CheckWeightSheet['Weight'].length - 6, CheckWeightSheet['Weight'].length), 19, getHeight(height))
            // let a = CheckWeightSheet['Weight'].match(/\d+/g)
            // console.log(a[a.length-1])
            // console.log(CheckWeightSheet['Weight'].indexOf(a[0]))
            // console.log(CheckWeightSheet['Weight'].indexOf(a[1]))
            height += 1
            doc.text('Total gross :', 37, getHeight(height))
            doc.text(`${addCommaInNumber(handleData['TotalGross'])}  kgs.`, 185, getHeight(height), 'right')
            height += 1
            doc.text('Total tare :', 37, getHeight(height))
            doc.text(`${addCommaInNumber(handleData['TotalTare'])}  kgs.`, 185, getHeight(height), 'right')
            height += 1
            doc.text('Total nett :', 37, getHeight(height))
            doc.text(`${addCommaInNumber(handleData['TotalNett'])}  kgs.`, 185, getHeight(height), 'right')
            height = 25
            doc.text(`Export license No.         ${handleData['License']}`, 19, getHeight(height))
            doc.save(`030811${handleData['License']}.pdf`)
          }
          else if (CheckWeightSheet['Weight'].indexOf('pasteboard boxes') != -1) {
            doc.text(CheckWeightSheet['Weight'].slice(0, 68), 40, getHeight(height))
            doc.text(CheckWeightSheet['Weight'].slice(68, CheckWeightSheet['Weight'].length - 23), 146, getHeight(height))
            doc.text(CheckWeightSheet['Weight'].slice(CheckWeightSheet['Weight'].length - 23, CheckWeightSheet['Weight'].length - 6), 158, getHeight(height))
            height += 1
            doc.text(CheckWeightSheet['Weight'].slice(CheckWeightSheet['Weight'].length - 6, CheckWeightSheet['Weight'].length), 19, getHeight(height))
            // let a = CheckWeightSheet['Weight'].match(/\d+/g)
            // console.log(a[a.length-1])
            // console.log(CheckWeightSheet['Weight'].indexOf(a[0]))
            // console.log(CheckWeightSheet['Weight'].indexOf(a[1]))
            height += 1
            doc.text('Total gross :', 37, getHeight(height))
            doc.text(`${addCommaInNumber(handleData['TotalGross'])}  kgs.`, 185, getHeight(height), 'right')
            height += 1
            doc.text('Total tare :', 37, getHeight(height))
            doc.text(`${addCommaInNumber(handleData['TotalTare'])}  kgs.`, 185, getHeight(height), 'right')
            height += 1
            doc.text('Total nett :', 37, getHeight(height))
            doc.text(`${addCommaInNumber(handleData['TotalNett'])}  kgs.`, 185, getHeight(height), 'right')
            height = 25
            doc.text(`Export license No.         ${handleData['License']}`, 19, getHeight(height))
            doc.save(`030811${handleData['License']}.pdf`)
          }
        }
      } else {
        alert('เกิดข้อผิดพลาด')
      }
    })
  }
  convertDeCodeText(text) {
    text = text.replace(/_S/g, ' ')
    text = text.replace(/_D/g, '.')
    text = text.replace(/_P/g, '%')
    text = text.replace(/_B/g, '/')
    if (text === 'blank') {
      return null
    } else {
      return text
    }
  }
  convertEnCodeText(text) {
    try {
      text = text.replace(/ /g, '_S')
      console.log(text)
      text = text.replace(/\./g, '_D')
      console.log(text)
      text = text.replace(/\%/g, '_P')
      console.log(text)
      text = text.replace(/\//g, '_B')
      console.log(text)
      if (text === 'blank') {
        return null
      } else {
        return text
      }
    } catch (error) {
      return null
    }
  }

  saveCertificate(idx, generalDescription) {
    let prepareData = {}
    const arr = ['currentDate', 'shippingDate', 'godown', 'shippingPort', 'Quality1', 'Quality2', 'Weight', 'title1', 'companyEN']
    const arrDes = ['wtf1', 'wtf2', 'No', 'bagQuantity', 'riceTypeID', 'PackingType1', 'PackingType11', 'PackingType12', 'PackingType2', 'logo', 'ShipperBehalf', 'destinationCity', 'vehicleName', 'TotalGross', 'TotalTare', 'TotalNett', 'License']
    arr.map((title) => {
      prepareData[title] = generalDescription[title]
    })
    arrDes.map((title) => {
      prepareData[title] = generalDescription['description'][idx][title]
    })
    prepareData['jobID'] = generalDescription['jobID']
    prepareData['License'] = `030811${prepareData['License']}`
    prepareData['subID'] = `${generalDescription['description'][idx]['subID']}`
    prepareData['NoOld'] = generalDescription['description'][idx]['NoOld'] ?? generalDescription['description'][idx]['No']
    let data = {
      riceID: prepareData['riceTypeID'],
      wtf: this.convertEnCodeText(generalDescription['description'][idx]['wtf1']),
      wtf2: this.convertEnCodeText(generalDescription['description'][idx]['wtf2']) || '',
      wtf3: this.convertEnCodeText(generalDescription['description'][idx]['wtf3']) || '',
    }
    console.log(prepareData)

    // axios.post(
    //   'https://backend1.riceinspections.com/testFB',
    //   {
    //     data: data
    //   }
    // )
 
    axios.post(
      'https://backend1.riceinspections.com/testDC',
      {
        data: prepareData,
      }
    ).then((res) => {
      console.log(res)
      if (res.data) {
        if (res.data.status == 'new') {
          alert('เพิ่มข้อมูลสำเร็จ')
          this.setState({
            ...this.state,
            redirect: true,
          })
        } else {
          alert('แก้ไขข้อมูลสำเร็จ')
          this.setState({
            ...this.state,
            redirect: true,
          })
        }
      } else {
        alert('เกิดข้อผิดพลาด')
      }
    })
  }
  render() {
    if (!this.state.isLoading) {
      return (
        <Container>
          <AdminNav />
          {this.renderRedirectToJob()}
          <div style={{ width: '100%', alignContent: 'left', textAlign: 'left', fontSize: '22px' }}  >
            <a href="javascript:void(0)" onClick={() => {
              this.setState({
                ...this.state,
                redirect: true
              })
            }}> {`<`} ย้อนกลับ
              </a>
          </div> 
          <OrderCertificate saveCertificate={this.saveCertificate} handleCertificate={this.handleCertificate}
            handleDescription={this.handleDescription}
            CertificateSheetDataOnline={this.state.CertificateSheetDataOnline}
            Certificate={this.state.CertificateSheetData} 
            desIndex={this.props.location.pageIndex}
            printOut={this.printOutCertificate} createCertificate={this.createCertificate}
            allCompany={this.props.location.allCompany} fullNameRiceAsSample={this.state.viewFullNameRiceAsSample}
            currentDate={this.props.location.currentDate} survey={this.state.survey}
            minusHeight={this.props.location.minusHeight} minusCurrentDate={this.props.location.minusCurrentDate}
            minusCertNo={this.props.location.minusCertNo}
          />
        </Container>
      )
    }
    else {
      return <div>
        <Container>
          <AdminNav />
        </Container>

      </div>
    }
  }
}  
